<template>
  <div id="profileDocuments" :style="cssVars">
    <!-- <v-layout v-if="ProfileDocument.submitted" class="ml-4">
      <span class="pf-text-green pf-font-18 font-weight-black">Final Document Submitted on: <span class="pf-text-menu font-italic font-weight-light">{{ ProfileDocument.submitted_date ? formatDate(ProfileDocument.submitted_date) : 'N/A' }}</span></span>
    </v-layout> -->
    <v-layout v-if="isHelpScreen" wrap class="pf-box-shadow border-radius-5 pa-2">
      <v-flex sm9 class="flex-start">
        <v-btn fab @click="backToListing" class="pf-btn-fab-sm">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <span class="font-weight-black ml-2 pf-font-20">Help - Profile Layout</span>
      </v-flex>
    </v-layout>
    <v-layout v-else-if="!currentDocument" wrap class="pf-box-shadow border-radius-5 pa-2">
      <v-flex sm9 class="flex-start">
        <v-btn fab :to="{ path: '/dashboard' }" class="pf-btn-fab-sm">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <span class="font-weight-black ml-2 pf-font-20">Custom Profile Book - Content</span>
      </v-flex>
      <v-layout sm3 wrap class="flex-end">
        <!-- <v-flex xs3 class="flex-row">
          <v-icon class="mr-1 pf-text-teal" size="26">
            volume_up
          </v-icon>
          <span class="pf-text-teal pf-font-14">Help</span>
        </v-flex> -->
        <v-flex xs6 class="flex-row">
          <v-avatar size="40px" :style="{ background: `url(${ coachAvatar }) 50% 50% / cover no-repeat`, border: 'solid 4px #fff', imageOrientation: 'none' }" class="pa-1 white avatar">
          </v-avatar>
          <v-flex class="flex-column">
            <span class="font-weight-black pf-font-14">{{ ProfileDocument.writer && ProfileDocument.writer.name ? ProfileDocument.writer.name : 'Not Found' }}</span>
            <span class="grey--text pf-font-11 text-uppercase">Writing Coach</span>
          </v-flex>
        </v-flex>
        <v-flex xs6 class="pf-text-teal flex-end px-3">
          <span @click="viewHelp" class="pf-text-teal pf-font-14 pf-border-lighter-1 px-2 border-radius-5 cursor-pointer">Help</span>
        </v-flex>
      </v-layout>
      <v-layout v-if="isAllApproved" class="pa-3 ma-2 pf-bg-teal flex-column border-radius-5 lh-25 pf-font-16">
        <p class="text-center white--text font-weight-medium letter-space-1 ma-0">
          Congratulations, Your content has been completed!
        </p>
        <template v-if="currentPDFStatus && currentPDFStatus.status === 'ParentReview' && ProfileDocument.pdf.template.file && ProfileDocument.pdf.template.file.webPath">
          <p class="text-center white--text font-weight-medium letter-space-1 ma-0">
            Profile team has submitted your <a class="teal-bg-link" :href="config.uploadPath + ProfileDocument.pdf.template.file.webPath" target="_blank">profile book</a>. You can approve it or add suggestions.
          </p>
          <v-flex class="flex-row flex-center">
            <v-btn
              class="pf-btn-sm-2 white pf-text-teal border-radius-15"
              title="Approve"
              @click.stop="approveProfilePDF"
            >
              Approve
            </v-btn>
            <v-btn
              class="pf-btn-sm-2 white pf-text-red border-radius-15"
              title="Suggestion"
              @click.stop="updatePDFStatus('Need Attention')"
            >
              Suggestion
            </v-btn>
          </v-flex>
        </template>
        <template v-else-if="currentPDFStatus && currentPDFStatus.status === 'Need Attention'">
          <p class="text-center white--text font-weight-medium letter-space-1 ma-0">
            Your suggestion to the profile PDF was submitted. Profile team is working on it.
          </p>
        </template>
        <template v-else-if="currentPDFStatus && currentPDFStatus.status === 'Approved'">
          <p class="text-center white--text font-weight-medium letter-space-1 ma-0">
            Your profile book was approved and submitted successfully.
          </p>
        </template>
        <template v-else>
          <p class="text-center white--text font-weight-medium letter-space-1 ma-0">
            We will get back to you with your custom designed profile book.
          </p>
        </template>
      </v-layout>
    </v-layout>
    <div v-if="!isHelpScreen" :class="{ 'mt-3': !currentDocument }">
      <v-tabs
        v-model="tabsModel"
        slider-color="#019d8c"
        class="pf-tabs-teal layout-main-tab pf-tab"
        id="top-tabs"
        @change="mainTabsChange"
      >
        <!-- <v-tab href="#tab-1" id="template-step-1">
          <span class="pa-1 pf-border-light-1 border-radius-15 mr-1 section-tab-counter">1</span>
          Design Preferences
          <v-icon
            id="template-step-2"
            class="ml-1"
            size="18"
            :class="statusTexts[getDesignPrefStatus].class"
            >{{ statusTexts[getDesignPrefStatus].icon }}</v-icon
        >
        </v-tab> -->
        <v-tab href="#tab-2" id="chapters-step-1">
          <span class="pa-1 pf-border-light-1 border-radius-15 mr-1 section-tab-counter">2</span>
          Chapters
          <v-icon
            class="ml-1"
            size="18"
            :class="statusTexts[getChaptersStatus].class"
            >{{ statusTexts[getChaptersStatus].icon }}</v-icon
          ></v-tab
        >
        <v-tab href="#tab-3" id="covers-step-1">
          <span class="pa-1 pf-border-light-1 border-radius-15 mr-1 section-tab-counter">3</span>
          Covers & Spread
          <v-icon
            class="ml-1"
            size="18"
            :class="statusTexts[coverStatus].class"
            >{{ statusTexts[coverStatus].icon }}</v-icon
          ></v-tab
        >

        <!-- <v-tab-item value="tab-1"> -->
          <!-- <v-card flat>
            <v-card-text>

              <v-layout>
                <p class="font-weight-regular pf-font-16 grey--text ma-0">
                  <template v-if="!!!design.template">Choose a design style you like</template>
                  <template v-else>You selected "{{ design.template }}" view</template>
                </p>
              </v-layout>

              <v-layout wrap class="pa-3 mt-2">
                <v-flex v-if="!profileSettings.design_templates || !profileSettings.design_templates.length" class="grey--text pf-font-16 flex-center">
                  No templates found
                </v-flex>
                <v-flex sm3 md2 class="flex-column flex-center pa-3" v-for="(template, d) in profileSettings.design_templates" :key="d">
                  <div id="template-step-3" class="elevation-2 flex-column flex-center cursor-pointer">
                    <a :href="template.file" target="_blank">
                      <v-hover v-slot="{ hover: designHover }">
                        <div class="pf-pos-relative">
                          <img class="pf-width-100p" :src="getFlipbookFirstPage(template.file)" :class="{ 'pf-border-teal-10': template.name === design.template }" title="Click to view" @click="{}/* viewFlipbook(template, d) */" />
                          <v-flex class="design-overlay flex-center" v-if="designHover">
                            <v-icon class="pf-text-white" size="22">search</v-icon>
                          </v-flex>
                        </div>
                      </v-hover>
                    </a>
                    <v-layout class="px-2 flex-column pf-width-100p">
                      <v-flex class="mb-2" id="template-step-4">
                        <v-checkbox :disabled="ProfileDocument.submitted" v-model="design.template" :value="template.name" :label="template.name" class="design-checkbox flex-center mt-1" color="teal" @change="saveDesignTemplate"></v-checkbox>
                      </v-flex>
                      <v-divider></v-divider>
                      <v-flex>
                        <v-layout wrap>
                          <v-flex xs6>
                            <v-btn icon title="Share" flat @click.stop="shareFlipbookLink(template)">
                              <v-icon class="pf-text-teal" size="18">share</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-flex xs6 class="flex-end">
                            <v-btn icon title="Download" flat @click.stop="downloadItem(template)">
                              <v-icon class="pf-text-teal" size="18">file_download</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>

              <next-button @next-clicked="() => { goToNextStep('2') }"></next-button>

            </v-card-text>
          </v-card> -->

          <!-- Modals -->
          <!-- <app-modal :active="flipbookViewModal" v-if="flipbookViewModal" :fullWidth="true" width="100%">
            <div slot="modal-content">
              <v-card>
                <v-layout class="flex-end">
                  <v-btn icon dark @click="closeFlipbookView">
                    <v-icon class="black--text">close</v-icon>
                  </v-btn>
                </v-layout>

                <v-layout>
                  <iframe :height="windowHeight" width="100%" frameborder="0" :src="currentTemplate.file" class="pf-border-dark-1"></iframe>
                </v-layout>
              </v-card>
            </div>
          </app-modal> -->

          <!-- <app-modal :active="isShareFlipbook" v-if="isShareFlipbook" width="40%">
            <div slot="modal-content">
              <v-card>
                <v-toolbar card dark class="pf-bg-teal">
                  <v-btn class="pf-modal-close" icon dark @click="isShareFlipbook = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                  <v-toolbar-title>Share Flipbook Link</v-toolbar-title>
                </v-toolbar>
                <v-form ref="flipbookLinkShareForm">
                  <v-card-text>
                    <v-layout class="pt-1">
                      <v-flex>
                        <v-text-field v-model="sharedFlipbookLink" :rules="[emailRules.required]" label="Flipbook Link"
                        readonly
                        class="required pr-4 pl-4"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout class="pt-1">
                      <v-flex>
                        <v-text-field v-model.trim="flipbookShareData.email" :rules="[emailRules.email, emailRules.required]" label="To email address"
                        class="required pr-4 pl-4"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout class="pb-1 pt-1">
                      <v-flex>
                        <v-textarea v-model.trim="flipbookShareData.message" label="Your message (optional)"
                        class="pr-4 pl-4"></v-textarea>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-form>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="pf-btn-text-white pf-bg-green"
                    @click="isShareFlipbook = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    class="pf-btn-text-white pf-bg-pink"
                    @click="submitFlipbookLink"
                  >
                    Share
                  </v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </app-modal> -->

        <!-- </v-tab-item> -->
        <v-tab-item value="tab-2">
          <v-card flat :class="{ 'no-shadow': currentDocument }">
            <v-card-text :class="{ 'pa-0': currentDocument }" id="chapter-content-tabs">
              <template v-if="currentDocument">
                <v-layout class="pf-box-shadow border-radius-5 pa-2 pl-2 pr-4 mb-3" :class="{ 'flex-space-between': $vuetify.breakpoint.smAndUp }">
                  <v-flex class="flex-row">
                    <v-btn fab @click="backToListing" class="pf-btn-fab-sm">
                      <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <span v-if="!isEditChapterTitle" class="font-weight-bold ml-2 pf-font-20 letter-space-p5">{{
                      currentDocument.name
                    }}</span>
                    <v-btn icon flat class="pf-text-teal" @click.stop="editChapterTitle" v-if="!isChapterDefault && !isEditChapterTitle && !ProfileDocument.submitted">
                      <v-icon size="18">edit</v-icon>
                    </v-btn>
                    <v-text-field v-if="isEditChapterTitle" v-model.trim="chapterTitleTemp" autofocus :hide-details="true" @blur="saveChapterTitle" @keyup.enter.prevent="saveChapterTitle" class="pf-width-250" height="20"></v-text-field>
                  </v-flex>
                  <v-flex :class="{ 'flex-end': $vuetify.breakpoint.smAndUp }">
                    <v-btn title="Delete chapter" icon flat @click.stop="deleteChapter" v-if="!isChapterRequired">
                      <v-icon class="pf-text-teal" size="20">delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>

                <v-tabs
                  v-model="chapterTabs"
                  slider-color="#019d8c"
                  class="mt-2 pf-tabs-teal pf-tab inner-tabs"
                  @change="chapterTabsChange"
                >
                  <v-tab href="#tab-1" id="content-step-1">Content</v-tab>
                  <v-tab href="#tab-2" id="photos-step-1">Photos</v-tab>

                  <v-tab-item value="tab-1">
                    <v-card-text class="pa-0">

                      <!-- Content -->
                      <v-layout wrap>
                        <!-- <v-flex :class="{ 'sm8': showTips || showComments }"> -->
                        <v-flex xs12>

                          <v-layout wrap :class="{ 'flex-space-between': $vuetify.breakpoint.smAndUp }">
                            <v-flex sm6>

                              <v-layout class="flex-column">
                                <v-layout :class="{ 'flex-row': $vuetify.breakpoint.smAndUp }">

                                  <!-- <v-btn
                                    class="pf-btn-sm-2 pf-bg-teal border-radius-15"
                                    title="Writing Assistant"
                                    @click.stop="openWritingAssistance"
                                    v-if="(!currentDocument.content.revision.length && currentDocument.content.status === 'Pending') || (currentDocument.content.revision.length === 1 && currentDocument.content.revision[currentDocument.content.revision.length - 1].owner === 'Parent' && ['Saved', 'Pending'].indexOf(currentDocument.content.status) > -1/*  && !isDefaultContentExists */)"
                                  >
                                    Writing Assistant
                                  </v-btn> -->

                                  <!-- <v-btn
                                    class="pf-btn-sm-2 pf-bg-teal border-radius-15"
                                    title="Check Grammer"
                                    @click.stop="correctContentGrammar"
                                    v-if="(!currentDocument.content.revision.length && currentDocument.content.status === 'Pending') || (currentDocument.content.revision.length === 1 && currentDocument.content.revision[currentDocument.content.revision.length - 1].owner === 'Parent' && ['Saved', 'Pending'].indexOf(currentDocument.content.status) > -1 && isManualContent)"
                                  >
                                    Check Grammer
                                  </v-btn> -->

                                  <div v-if="!ProfileDocument.submitted && currentDocument.content.revision[currentDocument.content.revision.length - 1].owner !== 'Parent' && currentDocument.content.status === 'Suggestion'">
                                    <v-btn
                                      class="pf-btn-sm-2 pf-bg-green border-radius-15"
                                      title="Approve Suggestion"
                                      @click.stop="updateContentStatus('Approved')"
                                    >
                                      Approve
                                    </v-btn>
                                    <v-btn
                                      class="pf-btn-sm-2 pf-bg-pink border-radius-15"
                                      title="Revise Content"
                                      @click.stop="editContent"
                                    >
                                      Revise
                                    </v-btn>
                                  </div>

                                  <v-btn
                                    class="pf-btn-sm-2 pf-bg-green border-radius-15"
                                    title="Submit Content"
                                    @click.stop="submitContent"
                                    v-else-if="!ProfileDocument.submitted && currentDocument.content.revision[currentDocument.content.revision.length - 1].owner === 'Parent' && ['Review', 'AgencyReview'].indexOf(currentDocument.content.status) === -1 && contentCanBeSubmitted()"
                                  >
                                    Submit
                                  </v-btn>

                                  <v-btn
                                    class="pf-btn-sm-2 pf-bg-green border-radius-15"
                                    title="Unsubmit Content"
                                    @click.stop="unSubmitContent"
                                    v-else-if="currentDocument.content.status === 'Review' && currentDocument.content.revision[currentDocument.content.revision.length - 1].owner === 'Parent'"
                                  >
                                    Unsubmit
                                  </v-btn>

                                  <p v-else class="font-weight-regular pf-font-16 grey--text ma-0">
                                    Content to be used in this chapter
                                  </p>


                                  <!-- <item-status class="ml-2" :status="currentDocument.content.status" :statusTexts="statusTexts"></item-status> -->
                                  
                                </v-layout>

                                <v-layout :class="{ 'flex-row': $vuetify.breakpoint.smAndUp }">

                                  <v-flex class="mt-2" v-if="!ProfileDocument.submitted && currentDocument.content.revision[currentDocument.content.revision.length - 1].owner !== 'Parent' && currentDocument.content.status === 'Suggestion'">
                                    <p class="ma-0 pf-font-16 grey--text">
                                      You may approve or revise the content suggested by the writer
                                    </p>
                                  </v-flex>

                                  <p
                                    v-else-if="currentDocument.content.status === 'Approved'"
                                    class="font-weight-normal pf-text-teal pf-font-14 ma-0 mt-2"
                                  >
                                    Approved on: {{ formatDate(currentDocument.content.status_date) }}
                                  </p>
                                  
                                </v-layout>

                              </v-layout>
                            </v-flex>

                            <v-flex :class="{ 'flex-end': $vuetify.breakpoint.smAndUp }">
                              <div class="flex-row">

                                <item-status class="ml-2" :status="currentDocument.content.status" :statusTexts="statusTexts"></item-status>

                                <v-flex class="border-radius-left-5 pf-border-teal-1 px-2 py-1 pf-cursor-pointer flex-row" :class="{ 'pf-bg-teal': showTips }" id="content-step-2">
                                  <div @click.stop="showCommentsTips('tips')">
                                    <v-icon :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }" size="18">info</v-icon>
                                    <span :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }">Tips</span>
                                  </div>
                                  <!-- <v-icon class="ml-2" :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }" size="20">volume_up</v-icon> -->
                                </v-flex>
                                <v-flex class="pf-border-teal-1 px-2 py-1 border-radius-right-5 pf-cursor-pointer" @click.stop="showCommentsTips('comments')" :class="{ 'pf-bg-teal': showComments }" id="content-step-3">
                                  <v-icon :class="{ 'pf-text-teal': !showComments, 'pf-text-white': showComments }" size="18">chat</v-icon>
                                  <span :class="{ 'pf-text-teal': !showComments, 'pf-text-white': showComments }">Comments</span>
                                </v-flex>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <v-layout wrap>
                        <v-flex :class="{ 'sm8': showTips || showComments }">

                          <v-layout class="mt-2" v-if="!ProfileDocument.submitted && contentCanBeSubmitted() && currentDocument.content.revision[currentDocument.content.revision.length - 1].owner === 'Parent' && ['Review', 'AgencyReview'].indexOf(currentDocument.content.status) === -1">
                            <v-flex>
                              <p class="ma-0 font-italic pf-font-14 grey--text">
                                Once you have finished writing for this chapter, please submit for review.
                              </p>
                            </v-flex>
                          </v-layout>

                          <v-flex class="mt-3">
                            <v-tabs
                              v-model="contentsModel"
                              slider-color="#019d8c"
                              class="pf-tabs-teal-sm pf-tab inner-tabs"
                              height="35"
                            >
                              <template
                                v-for="(contentVersion, r) in currentDocument
                                  .content.revision &&
                                currentDocument.content.revision.length
                                  ? currentDocument.content.revision
                                  : []"
                              >
                                <v-tab
                                  :href="`#tab-${r + 1}`"
                                  :id="r === 0 ? 'content-step-4' : ''"
                                  :key="r"
                                  >{{ r + 1 }}
                                </v-tab>
                                <v-tab-item
                                  :value="`tab-${r + 1}`"
                                  :key="r + currentDocument.content.revision.length + 1"
                                >
                                  <v-card-text class="pa-0" :class="{ 'errorEditor': isWordsExceeded }" id="content-step-5">
                                    <v-layout>
                                      <p>
                                        <span class="font-italic"
                                          >Version {{ r + 1 }} by
                                          <span class="font-weight-black">{{
                                            contentVersion.owner || "N/A"
                                          }}</span></span
                                        ><small
                                          class="ml-1 pf-text-warning"
                                          v-if="r !== currentDocument.content.revision.length - 1 ||
                                          contentVersion.owner !== 'Parent' ||
                                          ['Review', 'AgencyReview', 'Approved'].indexOf(currentDocument.content.status) > -1"
                                          >(read only)</small
                                        >
                                        <span class="ml-2 grey--text" v-else-if="!isWordsExceeded">
                                          ({{ remainingWords }} word{{ remainingWords !== 1 ? 's' : '' }} left of {{ (profileSettings.content_word_count || 250) }})
                                        </span>
                                        <span class="ml-2 pf-text-red" v-else>
                                          (Words count exceeded the limit of {{ (profileSettings.content_word_count || 250) }}, {{ remainingWords * (-1) }} extra words)
                                        </span>
                                      </p>
                                    </v-layout>
                                    <editor
                                      v-if="r === currentDocument.content.revision.length - 1"
                                      :options="editorOption"
                                      @onKeyUp="contentEditorKeyUp" @onChange="contentChanged"
                                      :content="content"
                                      :init="init"
                                      model-events="change keydown blur focusout focus paste"
                                      :api-key="config.tinymceEditorKey"
                                      :disabled="r !== currentDocument.content.revision.length - 1 || contentVersion.owner !== 'Parent' || ProfileDocument.submitted || ['Review', 'AgencyReview', 'Approved'].indexOf(currentDocument.content.status) > -1"
                                      v-model="currentRevisionContent"
                                      ref="content-editor"
                                    />
                                    <editor
                                      v-else
                                      :options="editorOption"
                                      :content="content"
                                      @onKeyUp="contentEditorKeyUp" @onChange="contentChanged"
                                      :init="init"
                                      model-events="change keydown blur focusout focus paste"
                                      :api-key="config.tinymceEditorKey"
                                      :disabled="r !== currentDocument.content.revision.length - 1 || contentVersion.owner !== 'Parent' || ProfileDocument.submitted || ['Review', 'AgencyReview', 'Approved'].indexOf(currentDocument.content.status) > -1"
                                      v-model="contentVersion.text"
                                      ref="content-editor"
                                    />
                                    <v-flex class="flex-space-between">
                                      <div>
                                        <span v-if="r !== currentDocument.content.revision.length - 1 || ['Review', 'AgencyReview'].indexOf(currentDocument.content.status) === -1" class="font-italic grey--text">Revision created on: {{ formatDate(contentVersion.date) }}</span>
                                        <span v-else-if="currentDocument.content.status === 'Approved'" class="font-italic grey--text">Revision approved on: {{ formatDate(currentDocument.content.status_date) }}</span>
                                        <span v-else-if="['Review', 'AgencyReview'].indexOf(currentDocument.content.status) > -1" class="font-italic grey--text">Revision submitted on: {{ formatDate(currentDocument.content.status_date) }}</span>
                                      </div>
                                      <span v-if="r === currentDocument.content.revision.length - 1 && contentVersion.owner === 'Parent'" class="font-italic grey--text">Maximum words count: {{ profileSettings.content_word_count || 250 }}</span>
                                    </v-flex>
                                  </v-card-text>
                                </v-tab-item>
                              </template>
                            </v-tabs>
                          </v-flex>

                          <!-- Save button -->
                          <!-- <v-flex class="mt-3 flex-end">
                            <v-btn
                              :disabled="!enableContentSave"
                              class="pf-btn pf-btn-save border-radius-15 pf-bg-teal"
                              @click="updateProfileDocument('content')"
                            >
                              <v-icon size="16" class="pr-1"
                                >check_circle</v-icon
                              >
                              <div>Save</div>
                            </v-btn>
                          </v-flex> -->
                        </v-flex>
                        <v-flex v-if="showTips || showComments" sm4 class="py-2 pr-0 pl-3">
                          <profile-comments :data="ProfileDocConversation" :loadingMessages="loadingMessages" :tipsTabs="tipsTabs" :identifier="currentDocument._id" :tipsText="currentTipsText" :message="message" @send="send" @close="closeCommentsTips" @changed="changedTipsTab"></profile-comments>
                        </v-flex>
                      </v-layout>

                    </v-card-text>
                  </v-tab-item>
                  <v-tab-item value="tab-2">
                    <!-- <v-card flat> -->
                    <v-card-text class="pa-0">

                      <!-- Content -->
                      <v-layout wrap>
                        <v-flex xs12 class="mt-2">

                          <v-layout wrap :class="{ 'flex-space-between': $vuetify.breakpoint.smAndUp }">
                            <v-flex sm6 class="flex-row">
                              <!-- <v-btn icon flat class="pf-text-teal" @click="closeAddPhotos" v-if="addingPhotos && !currentPhoto">
                                <v-icon size="24" class="pr-1">arrow_back</v-icon>
                              </v-btn> -->
                              <v-btn
                                class="pf-btn-sm-2 pf-bg-green border-radius-15"
                                v-if="!ProfileDocument.submitted && !currentPhoto && photosCanBeSubmitted()"
                                title="Submit Photos"
                                @click.stop="submitPhotos"
                              >
                                Submit
                              </v-btn>
                              <template v-else>
                                <p class="font-weight-regular pf-font-16 grey--text ma-0">
                                  Add up to {{ currentChapterDefaults.max_chapter_photos }} photos for this chapter and submit for review.
                                </p>
                              </template>
                            </v-flex>
                            <v-flex :class="{ 'flex-end': $vuetify.breakpoint.smAndUp }">
                              <div class="flex-row">
                                <v-flex class="border-radius-left-5 pf-border-teal-1 px-2 py-1 pf-cursor-pointer flex-row" :class="{ 'pf-bg-teal': showTips }">
                                  <div @click.stop="showCommentsTips('tips')">
                                    <v-icon :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }" size="18">info</v-icon>
                                    <span :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }">Tips</span>
                                  </div>
                                  <!-- <v-icon class="ml-2" :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }" size="20">volume_up</v-icon> -->
                                </v-flex>
                                <v-flex class="pf-border-teal-1 px-2 py-1 border-radius-right-5 pf-cursor-pointer" @click.stop="showCommentsTips('comments')" :class="{ 'pf-bg-teal': showComments }">
                                  <v-icon :class="{ 'pf-text-teal': !showComments, 'pf-text-white': showComments }" size="18">chat</v-icon>
                                  <span :class="{ 'pf-text-teal': !showComments, 'pf-text-white': showComments }">Comments</span>
                                </v-flex>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <v-layout wrap>
                        <v-flex :class="{ 'sm8': showTips || showComments }">

                          <v-layout wrap v-if="isPhotoView && currentPhoto" class="pa-3">
                            <v-flex class="pf-border-lighter-1">
                              <v-flex class="grey lighten-4 pf-border-bottom-lighter-1 flex-space-between pa-3">
                                <item-status :status="currentPhoto.status" class="flex" :statusTexts="statusTexts"></item-status>
                                <span class="font-weight-medium">Size: {{ currentPhoto.photo.size ? `${(currentPhoto.photo.size / 1000000).toFixed(2)} MB` : 'unknown' }}{{ currentPhotoDim ? `, Dimension: ${currentPhotoDim}` : '' }}</span>
                                <v-flex class="flex-end">
                                  <v-icon class="pf-text-teal" size="26" @click="changeCurrentPhoto('back')">arrow_back_ios</v-icon>
                                  <span class="font-italic">{{ currentPhotoIndex + 1 }} of {{ currentDocument.items.length }}</span>
                                  <v-icon class="pf-text-teal" size="26" @click="changeCurrentPhoto('next')">arrow_forward_ios</v-icon>
                                  <v-icon class="flex-end ml-4 pf-text-teal" title="Close" @click="closeViewPhoto" size="24">close</v-icon>
                                </v-flex>
                              </v-flex>

                              <v-layout wrap class="pa-3 grey lighten-3 flex-center flex-column">
                                <v-flex sm6>
                                  <a :href="currentPhoto.photo.original_url" target="_blank">
                                    <img class="image-view" :src="currentPhoto.photo.webview_url" />
                                  </a>
                                </v-flex>
                                <p class="ma-0">
                                  <label class="font-weight-black">Photo Caption: </label><span>{{ currentPhoto.photo.caption || 'No Caption' }}</span>
                                </p>
                              </v-layout>
                            </v-flex>
                          </v-layout>

                          <template v-else>
                            <v-layout class="flex-column" v-if="!currentDocument.items.length && !addingPhotos">
                              <v-flex
                                class="pf-bg-light-2 pf-border-teal-dash-1 mt-3 pa-4 flex-center flex-column"
                              >
                                <span class="font-weight-light pf-font-14"
                                  >0 Photos</span
                                >
                                <v-btn
                                  flat
                                  v-if="!ProfileDocument.submitted"
                                  class="pf-btn-sm pf-text-teal"
                                  title="Add Photos"
                                  @click.stop="selectPhotos"
                                >
                                  <v-icon>add</v-icon>
                                  Add Photos
                                </v-btn>
                              </v-flex>
                            </v-layout>
                            <v-layout wrap v-if="chapterTabs === 'tab-2'" class="flex-top mt-2">
                              <v-flex :class="{ 'pr-3 sm4': addingPhotos }">
                                <div :class="{ 'pf-border-lighter-1': currentDocument.items.length || addingPhotos }">
                                  <v-layout class="pf-bg-teal pa-2" v-if="currentDocument.items.length || addingPhotos">
                                    <v-flex xs10 class="pa-1 pf-font-16 white--text font-weight-medium letter-space-1">Chapter Photos</v-flex>
                                    <v-flex xs2 class="flex-end pa-1 pf-font-16 white--text font-weight-light">({{ currentDocument.items ? currentDocument.items.length : 0 }})</v-flex>
                                  </v-layout>

                                  <!-- Remove and add more photos -->
                                  <v-layout :class="{ 'flex-space-between': $vuetify.breakpoint.smAndUp, 'flex-column': !$vuetify.breakpoint.smAndUp }" v-if="!addingPhotos && currentDocument.items.length" class="pt-2 mt-1">
                                    <v-flex class="ml-1" :class="{ 'flex-end': $vuetify.breakpoint.smAndUp }">
                                      <v-btn
                                        v-if="selectedPhotos.length && !ProfileDocument.submitted"
                                        class="pf-btn-sm-2 border-radius-15 pf-bg-teal text-capitalize"
                                        @click="unAssignSelectedPhotos"
                                      >
                                        <v-icon size="16" class="mr-1"
                                          >do_not_disturb_on</v-icon
                                        >
                                        <div class="letter-space-1">Remove Selected</div>
                                      </v-btn>
                                      <v-btn
                                        v-if="!ProfileDocument.submitted && !addingPhotos"
                                        flat
                                        class="pf-btn-sm-2 pf-text-teal text-capitalize letter-space-1"
                                        title="Add More Photos"
                                        @click.stop="selectPhotos"
                                        :disabled="currentDocument.items && currentDocument.items.length >= currentChapterDefaults.max_chapter_photos"
                                      >
                                        <v-icon class="mr-1">add_circle</v-icon>
                                        Add More Photos
                                      </v-btn>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout wrap :class="{ 'pa-2': addingPhotos }">
                                    <isotope ref="chapterImages" v-if="currentDocument.items.length" :options="getOptions()" v-images-loaded:on.progress="layout" :list="currentDocument.items" class="pf-width-100p">
                                      <v-flex v-for="(photo, p) in currentDocument.items" :key="p" class="pa-2 chapter-item xs12" :class="{ 'sm4 md3': !addingPhotos && (showTips || showComments), 'sm6 md12': addingPhotos && (showTips || showComments), 'sm3 md2': !addingPhotos, 'sm6 md6': addingPhotos }">
                                        <div class="border-radius-5 pf-cursor-pointer pf-pos-relative flex-center" :class="{ /* 'pf-border-green-3': selectedPhotos.findIndex(x => x._id.toString() === photo._id.toString()) > -1, */ 'pf-border-red-2': isCaptionsMissing && (!photo.photo.caption || !photo.photo.caption.trim()) }" title="Click to manage">
                                          <v-card class="border-radius-5 pf-box-shadow">
                                            <div
                                              v-if="['Approved', 'Replace', 'AgencyReplace', 'Review', 'AgencyReview'].indexOf(photo.status) > -1"
                                              class="pa-2 flex-center"
                                            >
                                              <v-icon
                                                class="image_icon mr-1"
                                                size="16"
                                                :class="statusTexts[photo.status].class"
                                              >
                                                {{ statusTexts[photo.status].icon }}
                                              </v-icon>
                                              <span
                                                :class="statusTexts[photo.status].class"
                                                class="pf-font-12 font-weight-medium letter-space-1"
                                              >
                                                {{ statusTexts[photo.status].text }}
                                              </span>
                                            </div>
                                            <v-hover v-slot="{ hover: imageHover }">
                                              <div class="pf-pos-relative">
                                                <img class="pf-width-100p" :src="`${photo.photo.thumb_url ? photo.photo.thumb_url : photo.photo.webview_url ? photo.photo.webview_url : photo.photo.original_url}`" :alt="photo.photo.caption" @click.stop="viewPhoto(photo, p)">
                                                <v-btn absolute v-if="imageHover && photo.status !== 'Approved'" title="Remove photo" icon flat @click.stop="removePhoto(photo)" class="white top-right">
                                                  <v-icon class="pf-text-teal" size="18">delete</v-icon>
                                                </v-btn>
                                              </div>
                                            </v-hover>
                                            <v-layout class="wrap flex-center">
                                              <v-flex xs10 class="pa-1 flex-start">
                                                <span v-if="!isEdit || currentEditPhoto !== photo.photo.id" class="pf-font-12 pa-1 font-weight-regular">{{photo.photo.caption || 'No Caption'}}</span>
                                                <v-text-field v-if="isEdit && currentEditPhoto === photo.photo.id" v-model.trim="photo.photo.caption" autofocus :hide-details="true" class="ma-0 pa-0" height="20" @keyup.enter.prevent="{}" @change="savePhotoCaption"></v-text-field>
                                              </v-flex>
                                              <v-flex xs2 class="text-center pa-1">
                                                <v-icon class="pf-text-teal" size="16" @click.stop="editPhotoCaption(photo, p)" v-if="!isEdit || currentEditPhoto !== photo.photo.id">edit</v-icon>
                                                <v-icon class="pf-text-teal" size="16" @click.stop="isEdit = false" v-else>done</v-icon>
                                              </v-flex>
                                            </v-layout>
                                          </v-card>
                                        </div>
                                      </v-flex>
                                    </isotope>
                                    <v-flex v-else-if="addingPhotos" class="flex-center flex-column pa-2" id="photos-step-2">
                                      <p class="text-center ma-0 grey--text letter-space-p5 font-italic" v-if="!selectedPhotos.length">To add photos to this chapter, select photos from your albums or upload new photos.</p>
                                      <v-flex class="square-100 grey lighten-2 grey--text pf-font-20 font-weight-medium flex-center mt-3">None</v-flex>
                                    </v-flex>
                                  </v-layout>

                                  <!-- <v-layout class="flex-column pa-2" v-if="currentDocument.items.length">
                                    <v-layout v-for="(datePhotos, s) in groupedChapterPhotos" :key="s" class="mt-3 flex-column">
                                      <v-flex class="ml-1 flex-space-between">
                                        <span class="grey--text font-italic pf-font-14">
                                          {{ datePhotos.length }} Photo{{ datePhotos.length > 1 ? 's' : '' }}
                                        </span>
                                        <v-flex class="flex-end">
                                          <span class="grey--text font-weight-normal">Submitted on: {{ s !== 'N/A' ? formatDate(s) : s }}</span>
                                        </v-flex>
                                      </v-flex>
                                      <v-layout wrap v-if="chapterTabs === 'tab-2'">
                                        <isotope :ref="`chapterImages_${Object.keys(groupedChapterPhotos).indexOf(s)}`" v-if="datePhotos.length" :options="getOptions()" v-images-loaded:on.progress="layout" :list="datePhotos" class="pf-width-100p">
                                          <v-flex v-for="(photo, p) in datePhotos" :key="p" class="pa-2 chapter-item xs12" :class="{ 'sm4 md3': !addingPhotos && (showTips || showComments), 'sm6 md12': addingPhotos && (showTips || showComments), 'sm3 md2': !addingPhotos, 'sm6 md6': addingPhotos }">
                                            <div class="border-radius-5 pf-cursor-pointer pf-pos-relative flex-center" :class="{ 'pf-border-green-3': selectedPhotos.findIndex(x => x._id.toString() === photo._id.toString()) > -1 }" title="Click to view">
                                              <v-card class="border-radius-5 pf-box-shadow">
                                                <div
                                                  v-if="['Approved', 'Replace', 'Review'].indexOf(photo.status) > -1"
                                                  class="pa-2 flex-center"
                                                >
                                                  <v-icon
                                                    class="image_icon mr-1"
                                                    size="16"
                                                    :class="statusTexts[photo.status].class"
                                                  >
                                                    {{ statusTexts[photo.status].icon }}
                                                  </v-icon>
                                                  <span
                                                    :class="statusTexts[photo.status].class"
                                                    class="pf-font-12 font-weight-medium letter-space-1"
                                                  >
                                                    {{ statusTexts[photo.status].text }}
                                                  </span>
                                                </div>
                                                <v-hover v-slot="{ hover: imageHover }">
                                                  <div class="pf-pos-relative">
                                                    <img class="pf-width-100p" :src="`${photo.photo.thumb_url ? photo.photo.thumb_url : photo.photo.webview_url ? photo.photo.webview_url : photo.photo.original_url}`" :alt="photo.photo.caption" @click.stop="viewPhoto(photo, p)">
                                                    <v-btn absolute v-if="imageHover && photo.status !== 'Approved'" title="Remove photo" icon flat @click.stop="removePhoto(photo)" class="white top-right">
                                                      <v-icon class="pf-text-teal" size="18">delete</v-icon>
                                                    </v-btn>
                                                  </div>
                                                </v-hover>
                                                <v-layout class="wrap">
                                                  <v-flex xs10 class="pa-1">
                                                    <span v-if="!isEdit || currentEditPhoto !== photo.photo.id" class="pf-font-12 pa-1 font-weight-regular">{{photo.photo.caption || 'No Caption'}}</span>
                                                    <v-text-field v-if="isEdit && currentEditPhoto === photo.photo.id" v-model.trim="photo.photo.caption" autofocus :hide-details="true" class="ma-0 pa-0" height="20" @keyup.enter.prevent="savePhotoCaption" @change="savePhotoCaption"></v-text-field>
                                                  </v-flex>
                                                  <v-flex xs2 class="text-center pa-1">
                                                    <v-icon class="pf-text-teal" size="16" @click.stop="editPhotoCaption(photo, p)" v-if="!isEdit || currentEditPhoto !== photo.photo.id">edit</v-icon>
                                                    <v-icon class="pf-text-teal" size="16" @click.stop="isEdit = false" v-else>done</v-icon>
                                                  </v-flex>
                                                </v-layout>
                                              </v-card>
                                            </div>
                                          </v-flex>
                                        </isotope>
                                      </v-layout>
                                    </v-layout>
                                  </v-layout> -->

                                </div>
                              </v-flex>
                              <v-flex sm8 v-if="addingPhotos" class="flex-column">
                                <!-- Select photos -->
                                <v-layout class="flex-column pf-border-lighter-1">
                                  <!-- Top bar -->
                                  <v-flex class="grey darken-1 flex-space-between pa-1">
                                    <span class="white--text letter-space-1 ml-3 font-weight-medium pf-font-16">
                                      Photos{{ currentAlbum ? ` / ${currentAlbum.name}` : '' }}
                                    </span>
                                    <v-btn
                                      icon
                                      flat
                                      class="white--text"
                                      @click="closeAddPhotos"
                                    >
                                      <v-icon size="18" class="pr-1">close</v-icon>
                                    </v-btn>
                                  </v-flex>

                                  <!-- Upload photos -->
                                  <v-flex
                                    class="pf-bg-light-2 pf-border-pink-dash-1 ma-3 pa-2 flex-center pf-width-50p margin-auto-15"
                                    id="photos-step-3"
                                  >
                                    <v-btn
                                      flat
                                      class="pf-btn pf-text-teal"
                                      title="Upload Photos"
                                      @click="addImage()"
                                    >
                                      <v-icon>file_upload</v-icon>
                                      Upload New Photos
                                    </v-btn>
                                  </v-flex>

                                  <!-- Albums and photos tabs -->
                                  <v-tabs
                                    v-model="photosTabs"
                                    slider-color="#808080"
                                    class="pf-tab pf-tabs-flat chapter-photo-tabs pl-2 pr-2"
                                  >
                                    <v-tab href="#tab-1" id="photos-step-4">Albums<small class="ml-1">({{ listingAlbums.length }})</small></v-tab>
                                    <v-tab href="#tab-2" id="photos-step-5">All Photos<small class="ml-1">({{ allPhotos.length || 0 }})</small></v-tab>
                                    <v-tab href="#tab-3" id="photos-step-6">Printable Images<small class="ml-1">({{ printableImages.length || 0 }})</small></v-tab>

                                    <v-tab-item value="tab-1">
                                      <v-card-text class="pa-0" v-if="photosTabs === 'tab-1'">
                                        <p v-if="!listingAlbums.length" class="grey--text pf-font-14">
                                          No albums found
                                        </p>
                                        <template v-else-if="currentAlbum">
                                          <v-layout class="flex-start">
                                            <v-btn icon flat class="pf-text-teal" @click="backFromPhotos" v-if="currentAlbum">
                                              <v-icon size="24" class="pr-1">arrow_back</v-icon>
                                            </v-btn>
                                            <span v-if="currentAlbum" class="grey--text">{{ currentAlbum.photo ? currentAlbum.photo.length : 0 }} Photos</span>
                                            <p v-if="selectedPhotos.length" class="mb-0 mr-1 grey--text pf-font-14">
                                              {{ selectedPhotos.length + " selected" }}
                                            </p>
                                          </v-layout>
                                          <v-layout wrap class="pl-2 pr-2 pb-2 pt-0">
                                            <isotope ref="profileAlbumImages" :options="getOptions()" v-images-loaded:on.progress="layoutAllPhotos" :list="currentAlbum.photo" class="pf-width-100p">
                                              <v-flex v-for="(photo, p) in currentAlbum.photo" :key="p" class="pa-1 chapter-item xs12 sm3">
                                                <div class="pf-cursor-pointer pf-pos-relative flex-center" @click="selectPhoto(photo, true)" :class="{ 'pf-border-green-3': selectedPhotos.findIndex(x => x._id.toString() === photo._id.toString()) > -1 }" title="Click to add">
                                                  <img class="pf-width-100p" :src="`${photo.photo.thumb_url ? photo.photo.thumb_url : photo.photo.webview_url ? photo.photo.webview_url : photo.photo.original_url}`" :alt="photo.photo.caption">
                                                  <div class="image-metadata absolute-top-right flex-center font-weight-medium">{{ photo.photo.size ? `${(photo.photo.size / 1000000).toFixed(2)} MB` : 'Size unknown' }}</div>
                                                  <div v-if="isAlreadyAssigned(photo)" class="selected-image-overlay flex-center font-weight-medium">Already added</div>
                                                  <div v-else-if="isLowQualityImage(photo)" class="selected-image-overlay flex-center font-weight-medium">Web viewable only</div>
                                                </div>
                                              </v-flex>
                                            </isotope>
                                          </v-layout>
                                        </template>
                                        <v-layout v-else wrap>
                                          <isotope ref="albumList" :options="getOptions()" v-images-loaded:on.progress="layoutAlbums" :list="listingAlbums" class="pf-width-100p">
                                            <v-flex v-for="(albumItem, a) in listingAlbums" :key="a" class="pa-1 chapter-item pf-box-shadow xs12 sm3 pf-cursor-pointer" @click="viewAlbum(albumItem, a)">
                                              <div class="pf-pos-relative flex-center">
                                                <img v-if="albumItem.default_photo" class="pf-width-100p" :src="`${albumItem.default_photo.thumb_url ? albumItem.default_photo.thumb_url : albumItem.default_photo.webview_url ? albumItem.default_photo.webview_url : albumItem.default_photo.original_url}`">
                                                <img v-else class="pf-width-100p" src="/static/album-icon.jpg">
                                              </div>
                                              <v-layout class="wrap border-top-teal-4">
                                                <v-flex xs10 class="pa-1 font-weight-medium">{{ albumItem.name || 'Un-named' }}</v-flex>
                                                <v-flex xs2 class="text-center pa-1 white--text font-weight-light pf-bg-teal">{{ albumItem.photo ? albumItem.photo.length : 0 }}</v-flex>
                                              </v-layout>
                                            </v-flex>
                                          </isotope>
                                        </v-layout>
                                      </v-card-text>
                                    </v-tab-item>
                                    <v-tab-item value="tab-2">
                                      <v-card-text class="pa-0" v-if="photosTabs === 'tab-2'">
                                        <v-layout class="flex-start">
                                          <p v-if="selectedPhotos.length" class="mb-0 mr-1 grey--text pf-font-14">
                                            {{ selectedPhotos.length + " selected" }}
                                          </p>
                                        </v-layout>
                                        <v-layout wrap class="pl-2 pr-2 pb-2 pt-0">
                                          <isotope ref="profileAlbumImages" :options="getOptions()" v-images-loaded:on.progress="layoutAllPhotos" :list="allPhotos" class="pf-width-100p">
                                            <v-flex v-for="(photo, p) in allPhotos" :key="p" class="pa-1 chapter-item xs12 sm3">
                                              <div class="pf-cursor-pointer pf-pos-relative flex-center" @click="selectPhoto(photo, true)" :class="{ 'pf-border-green-3': selectedPhotos.findIndex(x => x._id.toString() === photo._id.toString()) > -1 }" title="Click to add">
                                                <img class="pf-width-100p" :src="`${photo.photo.thumb_url ? photo.photo.thumb_url : photo.photo.webview_url ? photo.photo.webview_url : photo.photo.original_url}`" :alt="photo.photo.caption">
                                                <div class="image-metadata absolute-top-right flex-center font-weight-medium">{{ photo.photo.size ? `${(photo.photo.size / 1000000).toFixed(2)} MB` : 'Size unknown' }}</div>
                                                <div v-if="isAlreadyAssigned(photo)" class="selected-image-overlay flex-center font-weight-medium">Already added</div>
                                                <div v-else-if="isLowQualityImage(photo)" class="selected-image-overlay flex-center font-weight-medium">Web viewable only</div>
                                              </div>
                                            </v-flex>
                                          </isotope>
                                        </v-layout>
                                      </v-card-text>
                                    </v-tab-item>
                                    <v-tab-item value="tab-3">
                                      <v-card-text class="pa-0" v-if="photosTabs === 'tab-3'">
                                        <v-layout class="flex-start">
                                          <p v-if="selectedPhotos.length" class="mb-0 mr-1 grey--text pf-font-14">
                                            {{ selectedPhotos.length + " selected" }}
                                          </p>
                                        </v-layout>
                                        <v-layout wrap class="pl-2 pr-2 pb-2 pt-0">
                                          <isotope ref="profileQualityImages" :options="getOptions()" v-images-loaded:on.progress="layoutQualityPhotos" :list="printableImages" class="pf-width-100p">
                                            <v-flex v-for="(photo, p) in printableImages" :key="p" class="pa-1 chapter-item xs12 sm3">
                                              <div class="pf-cursor-pointer pf-pos-relative flex-center" @click="selectPhoto(photo, true)" :class="{ 'pf-border-green-3': selectedPhotos.findIndex(x => x._id.toString() === photo._id.toString()) > -1 }" title="Click to add" id="photos-step-7">
                                                <img class="pf-width-100p" :src="`${photo.photo.thumb_url ? photo.photo.thumb_url : photo.photo.webview_url ? photo.photo.webview_url : photo.photo.original_url}`" :alt="photo.photo.caption">
                                                <div class="image-metadata absolute-top-right flex-center font-weight-medium">{{ photo.photo.size ? `${(photo.photo.size / 1000000).toFixed(2)} MB` : 'Size unknown' }}</div>
                                                <div v-if="isAlreadyAssigned(photo)" class="selected-image-overlay flex-center font-weight-medium">Already added</div>
                                              </div>
                                            </v-flex>
                                          </isotope>
                                        </v-layout>
                                      </v-card-text>
                                    </v-tab-item>
                                  </v-tabs>

                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </template>
                        </v-flex>
                        <v-flex v-if="showTips || showComments" sm4 class="py-2 pr-0 pl-3">
                          <profile-comments :data="ProfileDocConversation" :loadingMessages="loadingMessages" :tipsTabs="tipsTabs" :identifier="currentDocument._id" :tipsText="currentTipsText" :message="message" @send="send" @close="closeCommentsTips" @changed="changedTipsTab"></profile-comments>
                        </v-flex>
                      </v-layout>

                    </v-card-text>
                    <!-- </v-card> -->
                  </v-tab-item>
                </v-tabs>
              </template>
              <template v-else>
                <!-- info text -->
                <v-layout wrap v-if="!ProfileDocument.submitted && showChapterInfo" class="pf-pos-relative flex-center">
                  <v-flex
                    class="pf-pos-relative sm6 flex-row offset-sm-3 px-4 py-3 pf-box-shadow-2 border-radius-10"
                  >
                    <v-icon class="pa-1 right-0 top-0 cursor-pointer grey--text pf-pos-absolute pf-modal-close" size="22" @click="showChapterInfo = false">close</v-icon>
                    <v-icon class="pf-text-teal mr-2" size="40"
                      >info</v-icon
                    >
                    <p class="ma-0 grey--text letter-space-p5 font-italic">
                      To get you started, we have added some recommended
                      chapters. You may edit, delete or add chapters to create
                      your own profile layout! You may create up to {{ profileSettings.max_chapters || 10 }} chapters
                      for your profile.
                    </p>
                  </v-flex>
                </v-layout>

                <!-- info and add button -->
                <v-layout
                  class="font-weight-light mt-2 font-italic flex-center flex-space-between"
                  v-if="!ProfileDocument.submitted"
                >
                  <v-flex>
                    <p class="ma-0 grey--text font-weight-regular">
                      Click on a chapter to add/edit content and photos. Drag and drop to reorder.
                    </p>
                  </v-flex>
                  <v-flex class="flex-end">
                    <v-btn
                      id="chapters-step-3"
                      flat
                      class="pf-btn pf-text-teal"
                      title="Add Chapter"
                      @click="addFromDefaultChapter"
                      :disabled="(ProfileDocument.chapters && ProfileDocument.chapters.length >= (profileSettings.max_chapters || 10) || ProfileDocument.submitted)"
                    >
                      <v-icon class="mr-1">add_circle</v-icon>
                      <span class="text-capitalize font-weight-medium font-normal">New Chapter</span>
                    </v-btn>
                  </v-flex>
                </v-layout>

                <v-layout class="mt-3">
                  <draggable
                    v-model="ProfileDocument.chapters"
                    class="layout wrap"
                    handle=".chapterSortHandle"
                    @start="drag = true"
                    @end="drag = false"
                    @change="sortChapters"
                    forceFallback="false"
                  >
                    <v-flex
                      class="mb-3 single"
                      :class="{ 'xs12': $vuetify.breakpoint.xsOnly, 'sm4': $vuetify.breakpoint.smOnly, 'md-20p': $vuetify.breakpoint.mdAndUp }"
                      v-for="(chapter, i) in ProfileDocument.chapters"
                      :key="i"
                    >
                      <v-layout class="pa-3 flex-column">
                        <v-flex class="flex-space-between">
                          <span class="pf-font-15 grey--text text--darken-2 letter-space-1p5 text-uppercase font-weight-medium">Chapter {{ i + 1 }}</span>
                          <v-btn icon class="ma-0 chapterSortHandle" title="Change Order">
                            <v-icon size="20" color="grey lighten-1">open_with</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-layout :id="i === 0 ? 'chapters-step-2' : ''" class="flex-column overflow-hide pf-box-shadow-2 mt-1 border-radius-5 pt-3 pl-3 pr-3 cursor-pointer pf-width-100p" @click.stop="viewChapter(chapter, i)">
                          <v-layout
                            class="flex-column flex-center pf-pos-relative pb-2"
                          >
                            <span class="font-weight-black pf-font-16 letter-space-1">
                              {{ chapter.name }}
                            </span>

                            <!-- items -->
                            <span class="mt-3 font-weight-medium pf-font-12" @click.stop="selectPhotos(chapter, i)">
                              <span v-if="!chapter.items.length">0 Photos</span>
                              <span v-else>{{ currentChapterPhoto(i) }} of {{ chapter.items.length }} Photos</span>
                            </span>
                            <v-flex
                              v-if="!chapter.items.length"
                              class="pf-bg-light-2 pf-border-teal-dash-1 mt-1 pa-2 flex-center flex-column square-110"
                              @click.stop="selectPhotos(chapter, i)"
                              :id="i === 0 ? 'chapters-step-4' : ''"
                            >
                              <v-btn
                                flat
                                class="pf-btn-sm pf-text-teal"
                                title="Add Photos"
                                @click.stop="selectPhotos(chapter, i)"
                              >
                                <v-icon>add</v-icon>
                                Photos
                              </v-btn>
                            </v-flex>
                            <v-flex
                              v-else
                              class="flex-center flex-column pf-width-100p mt-1"
                              :id="i === 0 ? 'chapters-step-4' : ''"
                            > 
                              <v-layout
                                wrap
                                class="flex-center"
                                @click.stop="{}"
                              >
                                <v-carousel hide-delimiters height="110" :cycle="false" class="chapter-courosel" @change="chapterSliderChanged($event, i)">
                                  <v-carousel-item
                                    v-for="(photo, p) in chapter.items.filter(x => x.photo && x.photo.thumb_url)"
                                    :key="p"
                                  >
                                    <div class="v-responsive v-image v-carousel__item" @click.stop="selectPhotos(chapter, i)">
                                      <div class="v-image__image v-image__image--cover" :style="`background-image: url('${photo.photo.thumb_url}'); background-position: center center;`"></div>
                                      <div class="v-responsive__content"></div>
                                    </div>
                                  </v-carousel-item>
                                </v-carousel>
                                <!-- <v-flex
                                  sm3
                                  xs2
                                  v-for="(photo, p) in chapter.items
                                    .filter(x => x.photo && x.photo.thumb_url)
                                    .slice(0, $vuetify.breakpoint.xs ? 6 : 4)"
                                  :key="p"
                                  class="pa2"
                                >
                                  <div
                                    class="border-radius-5 thumb_image"
                                    :style="
                                      `background-image: url('${photo.photo.thumb_url}')`
                                    "
                                  ></div>
                                </v-flex> -->
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-layout class="pt-2 mx-m15 border-top-dark-1 flex-row flex-space-between pf-width-100p">
                            <span
                              class="pa-2 mb-2 pf-font-12 font-weight-medium letter-space-1"
                              :class="statusTexts[getChapterStatus(chapter)].class"
                              :id="i === 0 ? 'chapters-step-5' : ''"
                            >
                              <v-icon
                                class="ml-1"
                                size="16"
                                :class="
                                  statusTexts[getChapterStatus(chapter)].class
                                "
                                >{{
                                  statusTexts[getChapterStatus(chapter)].icon
                                }}</v-icon
                              >
                              {{
                                statusTexts[getChapterStatus(chapter)].text
                              }}
                            </span>
                            <v-layout class="flex-end mb-2 mr-3">
                              <v-badge color="green" overlap>
                                <!-- <template v-slot:badge>
                                  <span>3</span>
                                </template> -->
                                <v-icon size="20" color="grey">notifications</v-icon>
                              </v-badge>
                            </v-layout>
                          </v-layout>
                        </v-layout>

                      </v-layout>
                    </v-flex>
                  </draggable>
                </v-layout>
                
                <next-button @next-clicked="() => { goToNextStep('3') }"></next-button>
                
                
              </template>
            </v-card-text>
          </v-card>
          
          <!-- Choose from default chapters -->
          <app-modal :active="isAddFromDefaultChapters" v-if="isAddFromDefaultChapters" width="50%">
            <div slot="modal-content">
              <v-card>
                <v-toolbar card dark class="pf-bg-teal">
                  <v-btn class="pf-modal-close" icon dark @click="isAddFromDefaultChapters = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                  <v-toolbar-title>Add New Chapter</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-select 
                    v-model="selectedNewChapter" 
                    :items="unSelectedChapters" 
                    label="Choose from default chapter list"
                    class="pr-4 pl-4"
                    return-object
                  >
                  </v-select>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="pf-btn-text-white pf-bg-green"
                    @click="handleAddChapter"
                  >
                    Add Chapter
                  </v-btn>
                  <v-btn
                    class="pf-btn-text-white pf-bg-pink"
                    @click="closeAddChapter"
                  >
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </app-modal>

          <!-- Writing assistant -->
          <app-modal :active="writingAssistantActive" v-if="writingAssistantActive" width="70%">
            <div slot="modal-content">
              <v-card>
                <v-toolbar card dark class="pf-bg-teal">
                  <v-btn class="pf-modal-close" icon dark @click="writingAssistantActive = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                  <v-toolbar-title>Writing Assistant</v-toolbar-title>
                </v-toolbar>
                <v-form ref="writingAssistantForm">
                  <v-card-text>
                    <stepper-functions @submit="submitAIAnswers" @cancel="writingAssistantActive = false" :steps="AIQuestions.map(x => { return { title: x.question } })"></stepper-functions>
                  </v-card-text>
                </v-form>

              </v-card>
            </div>
          </app-modal>
        </v-tab-item>
        <v-tab-item value="tab-3">
          <v-card flat>
            <v-card-text>
              <!-- info and add button -->
              <v-layout class="flex-column">
                <v-layout :class="{ 'flex-space-between': $vuetify.breakpoint.smAndUp }">
                  <v-flex class="flex-align-start flex-column">
                    <v-btn
                      class="ma-0 mb-2 pf-btn-sm-2 pf-bg-green border-radius-15"
                      v-if="coversCanBeSubmitted()"
                      title="Submit Pictures"
                      @click.stop="submitCovers"
                    >
                      Submit Pictures
                    </v-btn>
                    <p class="grey--text font-weight-regular pf-font-16 ma-0">
                      Cover photos and center spread are mandatory.
                    </p>
                  </v-flex>
                  <v-flex class="flex-end">
                    <div class="flex-row">
                      <v-flex class="border-radius-left-5 pf-border-teal-1 px-2 py-1 pf-cursor-pointer flex-row" :class="{ 'pf-bg-teal': showTips }" id="covers-step-2">
                        <div @click.stop="showCommentsTips('tips')">
                          <v-icon :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }" size="18">info</v-icon>
                          <span :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }">Tips</span>
                        </div>
                        <!-- <v-icon class="ml-2" :class="{ 'pf-text-teal': !showTips, 'pf-text-white': showTips }" size="20">volume_up</v-icon> -->
                      </v-flex>
                      <v-flex id="covers-step-3" class="pf-border-teal-1 px-2 py-1 border-radius-right-5 pf-cursor-pointer" @click.stop="showCommentsTips('comments')" :class="{ 'pf-bg-teal': showComments }">
                        <v-icon :class="{ 'pf-text-teal': !showComments, 'pf-text-white': showComments }" size="18">chat</v-icon>
                        <span :class="{ 'pf-text-teal': !showComments, 'pf-text-white': showComments }">Comments</span>
                      </v-flex>
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout wrap class="mt-3">
                  <v-flex :class="{ 'sm8': showTips || showComments }">
                    
                    <v-layout wrap v-if="isCoverPhotoView && currentCoverPhoto" class="pa-3">
                      <v-flex class="pf-border-lighter-1">
                        <v-flex class="grey lighten-4 flex-align-center pf-border-bottom-lighter-1 flex-space-between pa-3">
                          <span class="font-weight-black pf-font-18 mb-2">{{ coverTexts[this.coverPhotoType] }}</span>
                          <item-status class="ml-2 flex" :status="currentCoverPhoto.status" :statusTexts="statusTexts"></item-status>
                          <span class="font-weight-medium">Size: {{ currentCoverPhoto.photo.size ? `${(currentCoverPhoto.photo.size / 1000000).toFixed(2)} MB` : 'unknown' }}{{ currentPhotoDim ? `, Dimension: ${currentPhotoDim}` : '' }}</span>
                          <v-flex class="flex-end">
                            <v-icon class="flex-end ml-4 pf-text-teal" title="Close" @click="closeViewCoverPhoto" size="24">close</v-icon>
                          </v-flex>
                        </v-flex>

                        <v-layout wrap class="pa-3 grey lighten-3 flex-center flex-column">
                          <v-flex sm6>
                            <a :href="getCoverImage(currentCoverPhoto.photo)" target="_blank">
                              <img class="image-view" :src="getCoverImage(currentCoverPhoto.photo)" />
                            </a>
                          </v-flex>
                          <p class="ma-0">
                            <label class="font-weight-black">Photo Caption: </label><span>{{ currentCoverPhoto.photo.caption || 'No Caption' }}</span>
                          </p>
                        </v-layout>
                      </v-flex>
                    </v-layout>

                    <v-layout wrap v-else>
                      <v-flex
                        class="mb-3"
                        :class="{ 'sm8 md6': i === 1, 'sm4 md3': i !== 1 }"
                        v-for="(page, i) in specialityPictures"
                        :key="i"
                      >
                        <v-layout class="pa-3 flex-column flex-center">
                          <span
                            class="grey--text pf-font-15 letter-space-1 text-uppercase font-weight-regular"
                            >{{ page.name }}<span v-if="page.key !== 'front_cover' && !profileSettings[`${page.key}_required`]" class="ml-1 pf-font-12 text-lowercase font-italic pf-text-warning">(optional)</span></span
                          >
                          <v-layout class="flex-column overflow-hide pf-box-shadow-2 mt-1 border-radius-5 pt-3 pl-3 pr-3 cursor-pointer pf-width-100p">
                            <v-layout
                              class="flex-column flex-center pf-pos-relative"
                            >
                              <!-- items -->
                              <v-flex
                                class="mt-2"
                                v-if="getSpecialPicture(page.key)"
                                @click.stop="viewCoverPhoto(page)"
                                :id="i === 0 ? 'covers-step-4' : ''"
                              >
                                <v-hover v-slot="{ hover: hoverCover }">
                                  <div class="pf-pos-relative">
                                    <img
                                      class="pf-cursor-pointer special_image"
                                      :src="getSpecialPicture(page.key)"
                                      :alt="page.key"
                                    />
                                    <v-btn absolute v-if="hoverCover && ['Approved'].indexOf(ProfileDocument.special_pictures[page.key].status) === -1" :title="`Remove ${page.name}`" icon flat @click.stop="removeSpecialPicture(page)" class="white top-right">
                                      <v-icon class="pf-text-teal" size="18">delete</v-icon>
                                    </v-btn>
                                  </div>
                                </v-hover>
                              </v-flex>

                              <v-flex
                                v-else
                                id="covers-step-4"
                                class="special_image pf-bg-light-2 pf-border-teal-dash-1 mt-1 pl-1 pr-1 pt-5 pb-5 flex-center flex-column"
                                :class="{ 'pl-5 pr-5 pt-1 pb-1': i === 1 }"
                              >
                                <span class="font-weight-black pf-font-12">{{
                                  page.size
                                }}</span>
                                <v-btn
                                  id="covers-step-5"
                                  flat
                                  class="pf-btn-sm pf-text-teal"
                                  title="Add Photo"
                                  @click="addImage('special', page.name)"
                                >
                                  <v-icon>add</v-icon>
                                  Photo
                                </v-btn>
                              </v-flex>

                            </v-layout>

                            <v-layout class="pt-2 mx-m15 border-top-dark-1 flex-row flex-space-between pf-width-100p">
                              <span
                                class="pa-2 mb-2 pf-font-12 font-weight-medium letter-space-1"
                                :class="statusTexts[ProfileDocument.special_pictures && ProfileDocument.special_pictures[page.key] ? ProfileDocument.special_pictures[page.key].status : 'Pending'].class"
                                id="covers-step-6"
                              >
                                <v-icon
                                  class="ml-1"
                                  size="16"
                                  :class="statusTexts[ProfileDocument.special_pictures &&ProfileDocument.special_pictures[page.key] ? ProfileDocument.special_pictures[page.key].status : 'Pending'].class"
                                >
                                  {{ statusTexts[ProfileDocument.special_pictures && ProfileDocument.special_pictures[page.key] ? ProfileDocument.special_pictures[page.key].status : "Pending"].icon }}
                                </v-icon>

                                {{ statusTexts[ProfileDocument.special_pictures && ProfileDocument.special_pictures[page.key] ? ProfileDocument.special_pictures[page.key].status : "Pending"].text }}

                              </span>
                              <v-layout class="flex-end mb-2 mr-3">
                                <v-badge color="green" overlap>
                                  <!-- <template v-slot:badge>
                                    <span>3</span>
                                  </template> -->
                                  <v-icon size="20" color="grey">notifications</v-icon>
                                </v-badge>
                              </v-layout>
                              <!-- <v-btn
                                flat
                                class="ma-0 white--text"
                                title="Edit"
                                @click.stop="viewChapter(chapter, i)"
                              >
                                <v-icon size="20">edit</v-icon>
                              </v-btn>
                              <v-btn
                                flat
                                class="ma-0 white--text"
                                title="Delete"
                                @click.stop="deleteChapter(chapter)"
                              >
                                <v-icon size="20">delete</v-icon>
                              </v-btn> -->
                            </v-layout>

                          </v-layout>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex v-if="showTips || showComments" sm4 class="py-2 pr-0 pl-3">
                    <profile-comments :data="ProfileDocConversation" :identifier="ProfileDocument._id" :loadingMessages="loadingMessages" :tipsTabs="tipsTabs" :tipsText="currentTipsText" :message="message" @send="send" @close="closeCommentsTips" @changed="changedTipsTab"></profile-comments>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>

    </div>
    <div v-else :class="{ 'mt-3': !currentDocument }">
      <profile-help :helpItems="FAQ"></profile-help>
    </div>
    <v-tour name="chaptersTour" :steps="stepsChapters" :callbacks="chaptersTourCallbacks" v-if="tours.chapters"></v-tour>
    <v-tour name="contentTour" :steps="stepsContent" :callbacks="contentTourCallbacks" v-if="tours.content"></v-tour>
    <v-tour name="photosTour" :steps="stepsPhotos" :callbacks="photosTourCallbacks" v-if="tours.photos"></v-tour>
    <v-tour name="coversTour" :steps="stepsCovers" :callbacks="coversTourCallbacks" v-if="tours.covers"></v-tour>
    <v-tour name="templateTour" :steps="stepsTemplates" :callbacks="templateTourCallbacks" v-if="tours.template"></v-tour>
  </div>
</template>
<script>
/* global session store config */
/* eslint-disable */
import Vue from "vue";

const ItemStatus = Vue.component('item-status', {
  props: ['status', 'statusTexts'],
  template: `<span
    v-if="['Pending', 'Saved'].indexOf(this.status) === -1"
    class="mr-2 pf-font-12 font-weight-medium letter-space-1"
    :class="this.statusTexts[this.status].class"
  >
    <v-icon size="16" :class="this.statusTexts[this.status].class">
      {{ this.statusTexts[this.status].icon }}
    </v-icon>
    {{ this.statusTexts[this.status].text }}
  </span><span v-else></span>`
});

const NextButton = Vue.component('next-button', {
  props: [],
  template: `<v-flex class="flex-end">
              <v-btn title="Go to Next" class="pf-bg-teal white--text" flat @click.stop="$emit('next-clicked')">
                Next
              </v-btn>
            </v-flex>`
});

import { mapGetters } from "vuex";
import {
  getCollection,
  update,
  getOne,
  remove,
  getVimeoJSON,
  request,
  create,
  conversationListPopulate,
  formatDate,
  sortList
} from "../../helpers/helpers";
import swal from "sweetalert2";
import draggable from "vuedraggable";
import AppModal from "../../components/AppModal.vue";
import ProfileComments from "./profile_comments";
import ProfileHelp from "./help";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import isotope from "../../components/Isotope";
import imagesLoaded from "vue-images-loaded";
import Editor from "@tinymce/tinymce-vue";
import { Chrome, Photoshop } from 'vue-color';
import { saveAs } from 'file-saver';
import JSZipUtils from 'jszip-utils';
import StepperFunctions from "../../components/StepperFunctions.vue";

// import VuePlyr from 'vue-plyr';
// import 'vue-plyr/dist/vue-plyr.css';
// Vue.use(VuePlyr);

import VueYouTubeEmbed from "vue-youtube-embed";
Vue.use(VueYouTubeEmbed);

import { vueVimeoPlayer } from "vue-vimeo-player";

const sleep = milliseconds => {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
};

export default {
  name: "profileDocumentsParent",
  components: {
    draggable,
    "vimeo-player": vueVimeoPlayer,
    "app-modal": AppModal,
    "stepper-functions": StepperFunctions,
    isotope,
    imagesLoaded,
    Editor,
    VuePerfectScrollbar,
    'chrome-picker': Chrome,
    'photoshop-picker': Photoshop,
    'profile-comments': ProfileComments,
    'profile-help': ProfileHelp,
    ItemStatus,
    NextButton
  },
  directives: {
    imagesLoaded
  },
  data: (vm) => ({
    Editor,
    formatDate,
    tabsModel: "tabs-model",
    contentsModel: "contents-model",
    chapterTabs: "chapter-tabs",
    tipsTabs: "tips-tabs",
    photosTabs: "tab-3",
    session: session,
    accountDetails: {},
    selectedData: false,
    config: config,
    currentDocument: null,
    currentDocumentIndex: -1,
    currentRevisionContent: "",
    realCurrentContent: '',
    addingPhotos: false,
    profileAlbum: null,
    uploadData: {},
    unassignedItems: [],
    specialityPictures: [
      {
        name: "Front Cover",
        key: "front_cover",
        size: "(576px X 720px)"
      },
      {
        name: "Center Spread",
        key: "center_spread",
        size: "(1152px X 720px)"
      },
      {
        name: "Back Cover",
        key: "back_cover",
        size: "(576px X 720px)"
      }
    ],
    statusTexts: {
      Pending: { text: "Open", icon: "info", class: "pf-text-red" },
      Saved: {
        text: "In Progress",
        icon: "hourglass_top",
        class: "pf-text-warning"
      },
      Review: {
        text: "Submitted",
        icon: "hourglass_top",
        class: "pf-text-teal"
      },
      Approved: { text: "Completed", icon: "verified", class: "pf-text-green" },
      Replace: { text: "Need Attention", icon: "notification_important", class: "pf-text-red" },
      AgencyReplace: { text: "Need Attention", icon: "notification_important", class: "pf-text-red" },
      Suggestion: {
        text: "Suggestion",
        icon: "assistant",
        class: "pf-text-warning"
      },
      AgencySuggestion: {
        text: "Agency Suggestion",
        icon: "assistant",
        class: "pf-text-warning"
      },
      WriterReview: {
        text: "Writer Review",
        icon: "hourglass_top",
        class: "pf-text-teal"
      },
      AgencyReview: {
        text: "Agency Review",
        icon: "hourglass_top",
        class: "pf-text-teal"
      }
    },
    // enableContentSave: false,
    init: {
      height: 400,
      selector: "chapterTextEditor",
      placeholder: "Write your introduction here and submit to your writing coach for review. Your writing coach will approve or suggest modifications to finalize the content.",
      paste_data_images: true,
      menubar: false,
      toolbar: "bold italic backcolor",
      plugins: ['wordcount'],
      custom_format: { block : 'h1', attributes : {title : 'Header'}, styles : {color : 'red'}}
    },
    editorOption: {
      placeholder: "Write your introduction here and submit to your writing coach for review. Your writing coach will approve or suggest modifications to finalize the content."
    },
    content: "",
    selectedPhotos: [],
    front_cover: null,
    back_cover: null,
    center_spread: null,
    helpVideoList: [],
    currentHelpVideo: null,
    vuePlayerOptions: {
      controls: ["play", "progress", "current-time", "mute", "fullscreen"]
    },
    showComments: false,
    showTips: false,
    loadingMessages: false,
    message: {
      content: '',
      conversation: '',
      sender: ''
    },
    isEdit: false,
    currentEditPhoto: null,
    currentEditPhotoIndex: -1,
    editPhotoItem: null,

    isEditChapterTitle: false,
    currentChapterEdit: null,
    currentChapterEditIndex: -1,
    editChapterItem: null,
    profileSettings: {
      // content_word_count: 250,
      // max_chapter_photos: 10,
      max_chapters: 10,
      tips_text: `<h5 class="mb-2 font-weight-bold">Here are some tips to complete your profile documents.</h5><p class="font-italic">The tips goes here</p>`,
      agency_approval_required: false
    },
    currentPhoto: null,
    currentPhotoIndex: -1,
    isPhotoView: false,
    currentPhotoDim: null,
    currentCoverPhoto: null,
    isCoverPhotoView: false,
    coverPhotoType: null,
    coverTexts: {
      'front_cover': 'Front Cover',
      'center_spread': 'Center Spread',
      'back_cover': 'Back Cover',
    },
    // design: {
    //   no_preference: false,
    //   max_colors: 10,
    //   template: '',
    //   colors: []
    // },
    // templateItems: [
    //   { name: 'Classic', file: 'https://cdn.parentfinder.com/parent/5f0af437fc253d0be2015280/Flipbook/5f0dd4c4dc32fa1373abc9fe/16_1384.html' },
    //   { name: 'Contemporary', file: 'https://cdn.parentfinder.com/parent/5ff77a5e7032fd448c419cdc/Flipbook/601492ece4dba16a41eef24f/21_1013.html' },
    //   { name: 'Minimalist', file: 'https://cdn.parentfinder.com/parent/5ffd074fa41d4526a80e894a/Flipbook/6051ed747e74d9374909e190/21_1022.html' },
    //   { name: 'Style 4', file: 'https://cdn.parentfinder.com/parent/5ff665c4775f5044c149fc0e/Flipbook/603cf2e0d6021a25405a03fd/21_1011.html' },
    //   { name: 'Style 5', file: 'https://cdn.parentfinder.com/parent/5ff67e35775f5044c14a83bb/Flipbook/601dc4c3d6fe410dc73a7195/21_1012.html' },
    //   { name: 'Style 6', file: 'https://cdn.parentfinder.com/parent/5fff93b1bc26d8324d2e1dd9/Flipbook/601c7b5ab8f6fe60c6b09cca/21_1026.html' }
    // ],
    // currentTemplate: null,
    // currentTemplateIndex: -1,
    // flipbookViewModal: false,
    // pickers: {
    //   pickColor1: false,
    //   pickColor2: false,
    //   pickColor3: false,
    //   pickColor4: false,
    //   pickColor5: false,
    //   pickColor6: false,
    //   pickColor7: false,
    //   pickColor8: false,
    //   pickColor9: false,
    //   pickColor10: false
    // },
    // isSaveColors: false,
    // isSaveTemplate: false,
    // pickDesignModal: false,
    // tempColor: null,
    topTabsDisplay: 'block',
    chapterTitleTemp: '',
    currentAlbum: null,
    currentAlbumIndex: -1,
    // isShareFlipbook: false,
    sharedFlipbookLink: '',
    flipbookShareData: {
      email: '',
      message: ''
    },
    emailRules: {
      email: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(v) || 'Please enter valid email address',
      required: value => !!value || 'Field is required.'
    },
    chapterPhotoSlides: {},
    isWordsExceeded: false,
    remainingWords: null,
    isCaptionsMissing: false,
    currentTipsText: `<h5 class="mb-2 font-weight-bold">Here are some tips to complete your profile documents.</h5><p class="font-italic">The tips goes here</p>`,
    isHelpScreen: false,
    FAQ: [],
    showChapterInfo: true,
    writingAssistantActive: false,
    unSelectedChapters: [],
    isAddFromDefaultChapters: false,
    selectedNewChapter: null,
    currentChapterDefaults: {},
    isManualContent: false,
    tours: {
      template: false,
      chapters: false,
      content: false,
      photos: false,
      covers: false
    },

    stepsTemplates: [
      {
        target: '#template-step-1',
        /* header: {
          title: 'Choose Template',
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: `You can choose the <strong>Design Template</strong> in this tab`
      },
      {
        target: '#template-step-2',
        /* header: {
          title: 'View Status'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'You can check this icon to know the <strong>status</strong> of this section'
      },
      {
        target: '#template-step-3',
        /* header: {
          title: 'View Template'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'You can cick here to <strong>view</strong> the <strong>Design Template</strong>'
      },
      {
        target: '#template-step-4',
        /* header: {
          title: 'Select a Template'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: '<strong>Select</strong> or <strong>unselect</strong> a template here'
      }
    ],
    templateTourCallbacks: {
      onSkip: () => { vm.exitTour('PF.ProfileDoc.Template.Expired', 'template') },
      onFinish: () => { vm.exitTour('PF.ProfileDoc.Template.Expired', 'template') },
      onStop: () => { vm.exitTour('PF.ProfileDoc.Template.Expired', 'template') }
    },
    stepsChapters: [
      {
        target: '#chapters-step-1',
        /* header: {
          title: 'Manage Chapters',
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: `The profile layout <strong>Chapters</strong> can be configured under this tab`
      },
      {
        target: '#chapters-step-2',
        /* header: {
          title: 'Chapter'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'Each box represents a <strong>Chapter</strong>, clicking on it will take you to the chapter content'
      },
      {
        target: '#chapters-step-3',
        /* header: {
          title: 'Add New Chapter'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'You can add <strong>New Chapters</strong> here.'
      },
      {
        target: '#chapters-step-4',
        /* header: {
          title: 'Chapter Photos'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'Click here to manage the chapter <strong>Photos</strong>.'
      },
      {
        target: '#chapters-step-5',
        /* header: {
          title: 'Chapter Status'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'This represents the <strong>Current status</strong> of the chapter.'
      }
    ],
    chaptersTourCallbacks: {
      onSkip: () => { vm.exitTour('PF.ProfileDoc.Chapters.Expired', 'chapters') },
      onFinish: () => { vm.exitTour('PF.ProfileDoc.Chapters.Expired', 'chapters') },
      onStop: () => { vm.exitTour('PF.ProfileDoc.Chapters.Expired', 'chapters') }
    },
    stepsContent: [
      {
        target: '#content-step-1',
        /* header: {
          title: 'Chapter Content',
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: `The <strong>Chapter Content</strong> can be configured under this tab`
      },
      {
        target: '#content-step-2',
        /* header: {
          title: 'Chapter Tips'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'It has some tips for you to write the <strong>Chapter Content</strong>.'
      },
      {
        target: '#content-step-3',
        /* header: {
          title: 'Comments'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'This section lists the <strong>Comments & Conversations</strong> on this chapter. You can <string>Message</strong> to your writing coach here.'
      },
      {
        target: '#content-step-4',
        /* header: {
          title: 'Content Versions'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'Here you have each <strong>Versions</strong> of the content until it gets approved.'
      },
      {
        target: '#content-step-5',
        /* header: {
          title: 'Edit Content'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: '<strong>Edit</strong> your chapter content in this editor. And <strong>Submit</strong> the content for the writing coach review once completed.'
      }
    ],
    contentTourCallbacks: {
      onSkip: () => { vm.exitTour('PF.ProfileDoc.Content.Expired', 'content') },
      onFinish: () => { vm.exitTour('PF.ProfileDoc.Content.Expired', 'content') },
      onStop: () => { vm.exitTour('PF.ProfileDoc.Content.Expired', 'content') }
    },
    stepsPhotos: [
      {
        target: '#photos-step-1',
        /* header: {
          title: 'Chapter Photos',
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: `The <strong>Chapter Photos</strong> can be managed under this tab`
      },
      {
        target: '#photos-step-2',
        /* header: {
          title: 'Selected Photos'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: `This section will list the photos you <strong>Already Added</strong> to this chapter. You can either upload new photos or select printable photos from your existing albums listed in the right hand side.`
      },
      {
        target: '#photos-step-3',
        /* header: {
          title: 'Upload Photos'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'You can upload new photos here if you want to add a <strong>New Photo</strong> to the chapter.'
      },
      {
        target: '#photos-step-4',
        /* header: {
          title: 'Albums'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'Here are your <strong>Profile Albums</strong> from which you can choose images.'
      },
      {
        target: '#photos-step-5',
        /* header: {
          title: 'All Photos'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'This will have a list of <strong>All Photos</strong> you have in Parentfinder.'
      },
      {
        target: '#photos-step-6',
        /* header: {
          title: 'Printable Images'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'This will have a list of <strong>Printable Images</strong> which can be selected for the chapter.'
      },
      {
        target: '#photos-step-7',
        /* header: {
          title: 'Select Photo'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'You can add a printable image <strong>Just by Clicking</strong> on it and then you can add a title if not exists. You can <strong>Submit</strong> the photos for review once you are done.'
      }
    ],
    photosTourCallbacks: {
      onSkip: () => { vm.exitTour('PF.ProfileDoc.Photos.Expired', 'photos') },
      onFinish: () => { vm.exitTour('PF.ProfileDoc.Photos.Expired', 'photos') },
      onStop: () => { vm.exitTour('PF.ProfileDoc.Photos.Expired', 'photos') }
    },
    stepsCovers: [
      {
        target: '#covers-step-1',
        /* header: {
          title: 'Covers & Spread',
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: `The <strong>Cover Images</strong> and <strong>Center Spread</strong> can be configured here`
      },
      {
        target: '#covers-step-2',
        /* header: {
          title: 'Tips'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'It has some <strong>Tips</strong> for you while uploading the covers and spread.'
      },
      {
        target: '#covers-step-3',
        /* header: {
          title: 'Comments'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'This section lists the <strong>Comments & Conversations</strong> on covers and spread. You can <string>Message</strong> to your writing coach here.'
      },
      {
        target: '#covers-step-4',
        /* header: {
          title: 'Selected Image'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'The <strong>Uploaded</strong> image will be shown here.'
      },
      {
        target: '#covers-step-5',
        /* header: {
          title: 'Upload Image'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'You can upload the image by clicking here. We will force you to crop the image into the above mentioned size. You can submit once you uploaded all the required images.'
      },
      {
        target: '#covers-step-6',
        /* header: {
          title: 'Image Status'
        }, */
        params: {
          placement: 'bottom',
          enableScrolling: false
        },
        content: 'This indicates the <strong>Current Status</strong> of the image.'
      }
    ],
    coversTourCallbacks: {
      onSkip: () => { vm.exitTour('PF.ProfileDoc.Covers.Expired', 'covers') },
      onFinish: () => { vm.exitTour('PF.ProfileDoc.Covers.Expired', 'covers') },
      onStop: () => { vm.exitTour('PF.ProfileDoc.Covers.Expired', 'covers') }
    }
  }),
  computed: {
    ...mapGetters(["Account", "AlbumPhoto"]),
    ProfileDocument: {
      get() {
        return store.state.ProfileDocument;
      },
      set(value) {
        store.commit("setProfileDocument", value);
      }
    },
    ProfileDocConversation: {
      get() {
        return store.state.ProfileDocConversation;
      },
      set(value) {
        store.commit("setProfileDocConversation", value);
      }
    },
    FAQList: {
      get () {
        return store.state.Faq;
      },
      set (value) {
        store.commit('setFaq', value);
      }
    },
    albumList: {
      get () {
        return store.state.AlbumPhotosPopulated;
      },
      set (value) {
        store.commit('setAlbumPhotosPopulated', value);
      }
    },
    isChapterDefault () {
      let defaultIndex = this.profileSettings.default_chapters.findIndex(x => x.name === this.currentDocument.name);
      if (defaultIndex === -1) {
        if (this.currentDocument.name === `About ${this.Account.name.split(" / ")[0]}`) {
          defaultIndex = this.profileSettings.default_chapters.findIndex(x => x.name === 'About Parent 1');
        } else if (this.currentDocument.name === `About ${this.Account.name.split(" / ")[1]}`) {
          defaultIndex = this.profileSettings.default_chapters.findIndex(x => x.name === 'About Parent 2');
        }
      }
      if (defaultIndex > -1) {
        return this.profileSettings.default_chapters[defaultIndex].default || false;
      }
      return false;
    },
    isChapterRequired () {
      let defaultIndex = this.profileSettings.default_chapters.findIndex(x => x.name === this.currentDocument.name);
      if (defaultIndex === -1) {
        if (this.currentDocument.name === `About ${this.Account.name.split(" / ")[0]}`) {
          defaultIndex = this.profileSettings.default_chapters.findIndex(x => x.name === 'About Parent 1');
        } else if (this.currentDocument.name === `About ${this.Account.name.split(" / ")[1]}`) {
          defaultIndex = this.profileSettings.default_chapters.findIndex(x => x.name === 'About Parent 2');
        }
      }
      if (defaultIndex > -1) {
        return this.profileSettings.default_chapters[defaultIndex].required || false;
      }
      return false;
    },
    defaultChapters () {
      let chapters = [];
      if (this.profileSettings && this.profileSettings.default_chapters && Object.keys(this.profileSettings.default_chapters).length) {
        this.profileSettings.default_chapters.filter(x => x.default && x.name !== 'new_chapters' && (!x.accountType || ['Both', this.Account.account_type].indexOf(x.accountType) > -1)).forEach(chapter => {
          if (chapter && chapter.name) {
            
            let content = chapter.content && chapter.content.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length ? { revision: [{ text: chapter.content, owner: 'Parent', date: (new Date()).toISOString() }], status: 'Saved', status_date: (new Date()).toISOString() } : { revision: [], status: 'Pending' };

            if (chapter.name === 'About Parent 1') {
              chapters.push({ name: `About ${this.Account.name.split(' / ')[0]}`, content });
            } else if (chapter.name === 'About Parent 2' && this.Account.account_type === 'Couple' && this.Account.name.split(' / ')[1]) {
              chapters.push({ name: `About ${this.Account.name.split(' / ')[1]}`, content });
            } else {
              chapters.push({ name: chapter.name, content });
            }
          }
        });
      }
      return chapters;
    },
    windowHeight () {
      return window.innerHeight - 75;
    },
    listingAlbums () {
      return this.albumList && this.albumList.length ? this.albumList.filter(x => /* ['Normal', 'Profile'].indexOf(x.type) > -1 && */ x.photo && x.photo.length) : [];
    },
    allPhotos () {
      let photos = [];
      if (this.albumList.length) {
        for (let album in this.albumList) {
          if (this.albumList[album] && this.albumList[album].photo && this.albumList[album].photo.length) {
            this.albumList[album].photo.forEach(p => {
              if (this.isAlreadyAssigned(p) || this.isLowQualityImage(p)) {
                p.order = 0;
              } else {
                p.order = 1;
              }
            });
            photos = photos.concat(this.albumList[album].photo);
          }
        }
      }
      /* Sort the photos */
      photos = photos.sort((a, b) => b.order - a.order );
      return photos;
    },
    printableImages () {
      let photos = [];
      if (this.albumList.length) {
        for (let album in this.albumList) {
          if (this.albumList[album] && this.albumList[album].photo && this.albumList[album].photo.length) {
            let printableImages = this.albumList[album].photo.filter(x => !this.isLowQualityImage(x));
            printableImages.forEach(p => {
              if (this.isAlreadyAssigned(p)) {
                p.order = 0;
              } else {
                p.order = 1;
              }
            });
            photos = photos.concat(printableImages);
          }
        }
      }
      /* Sort the photos */
      photos = photos.sort((a, b) => b.order - a.order );
      return photos;
    },
    hasMediatorListener() {
      return (
        window.getApp._events &&
        window.getApp._events.NEW_ALBUM_PHOTO &&
        window.getApp._events.NEW_ALBUM_PHOTO.length
      );
    },
    currentPhotosStatus() {
      let status = "Pending";
      if (this.currentDocument) {
        if (
          this.currentDocument.items.filter(x => x.status === "Suggestion")
            .length
        ) {
          status = "Suggestion";
        } else if (
          this.currentDocument.items.filter(x => x.status === "Replace").length
        ) {
          status = "Replace";
        } else if (
          this.currentDocument.items.filter(x => x.status === "Pending").length
        ) {
          status = "Pending";
        } else if (
          this.currentDocument.items.filter(x => x.status === "Saved").length
        ) {
          status = "Saved";
        } else if (
          this.currentDocument.items.filter(x => x.status === "Review").length
        ) {
          status = "Review";
        } else if (
          this.currentDocument.items.length &&
          this.currentDocument.items.filter(x => x.status === "Approved")
            .length === this.currentDocument.items.length
        ) {
          status = "Approved";
        }
      }
      return status;
    },
    getChaptersStatus() {
      let statuses = [];
      let doc = this.ProfileDocument;
      if (doc) {
        if (doc.chapters && doc.chapters.length) {
          doc.chapters.forEach(chapter => {
            if (chapter.content && chapter.content.status) {
              statuses.push(chapter.content.status);
            } else {
              statuses.push("Pending");
            }
            if (chapter.items && chapter.items.length) {
              chapter.items.forEach(photo => {
                if (photo && photo.status) {
                  statuses.push(photo.status);
                }
              });
            } else {
              statuses.push("Pending");
            }
          });          
        } else {
          statuses.push("Pending");
        }

        if (statuses.length) {
          if (statuses.indexOf("Suggestion") > -1) {
            return 'Suggestion';
          } else if (statuses.indexOf("Replace") > -1) {
            return 'Replace';
          } else if (statuses.indexOf("Pending") > -1) {
            return 'Pending';
          } else if (statuses.indexOf("AgencySuggestion") > -1) {
            return 'AgencySuggestion';
          } else if (statuses.indexOf("Saved") > -1) {
            return 'Saved';
          } else if (statuses.indexOf("Review") > -1) {
            return 'Review';
          } else if (statuses.indexOf("AgencyReview") > -1) {
            return 'AgencyReview';
          } else if (statuses.filter(x => x === "Approved").length === statuses.length) {
            return 'Approved';
          } else {
            return 'Pending';
          }
        } else {
          return 'Pending';
        }
          
      } else {
        return 'Pending';
      }
    },  
    coverStatus() {
      let statuses = [];
      let doc = this.ProfileDocument;
      if (doc) {

        if (doc.special_pictures && Object.keys(doc.special_pictures).length) {
          let special = doc.special_pictures;
          if (special.front_cover && special.front_cover.status) {
            statuses.push(special.front_cover.status);
          } else {
            statuses.push('Pending');
          }
          if (this.profileSettings.back_cover_required) {
            if (special.back_cover && special.back_cover.status) {
              statuses.push(special.back_cover.status);
            } else {
              statuses.push('Pending');
            }
          }
          if (this.profileSettings.center_spread_required) {
            if (special.center_spread && special.center_spread.status) {
              statuses.push(special.center_spread.status);
            } else {
              statuses.push('Pending');
            }
          }
        }

        if (statuses.length) {
          if (statuses.indexOf("Suggestion") > -1) {
            return 'Suggestion';
          } else if (statuses.indexOf("Replace") > -1) {
            return 'Replace';
          } else if (statuses.indexOf("AgencySuggestion") > -1) {
            return 'AgencySuggestion';
          } else if (statuses.indexOf("Pending") > -1) {
            return 'Pending';
          } else if (statuses.indexOf("Saved") > -1) {
            return 'Saved';
          } else if (statuses.indexOf("Review") > -1) {
            return 'Review';
          } else if (statuses.indexOf("AgencyReview") > -1) {
            return 'AgencyReview';
          } else if (statuses.filter(x => x === "Approved").length === statuses.length) {
            return 'Approved';
          } else {
            return 'Pending';
          }
        } else {
          return 'Pending';
        }
          
      } else {
        return 'Pending';
      }
    },
    // getDesignPrefStatus() {
    //   let statuses = [];
    //   let doc = this.ProfileDocument;
    //   if (doc && doc.design) {

    //     let design = doc.design;
    //     // if (typeof design.no_preference !== 'undefined') {
    //     //   return 'Approved';
    //     // }
    //     // if (design.colors && design.colors.length) {
    //     //   statuses.push('Approved');
    //     // } else {
    //     //   statuses.push('Pending');
    //     // }
    //     if (design.template && design.template) {
    //       statuses.push('Approved');
    //     } else {
    //       statuses.push('Pending');
    //     }

    //     if (statuses.length) {
    //       if (statuses.indexOf("Pending") > -1) {
    //         return 'Pending';
    //       } else if (statuses.filter(x => x === "Approved").length === statuses.length) {
    //         return 'Approved';
    //       } else {
    //         return 'Pending';
    //       }
    //     } else {
    //       return 'Pending';
    //     }
          
    //   } else {
    //     return 'Pending';
    //   }
    // },
    isDefaultContentExists () {
      if (this.profileSettings.default_chapters && this.profileSettings.default_chapters.length) {
        let configIndex = this.profileSettings.default_chapters.findIndex(x => x.name === this.currentDocument.name);
        if (configIndex > -1) {
          return this.profileSettings.default_chapters[configIndex].content && this.profileSettings.default_chapters[configIndex].content.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length;
        }
      } else if (this.profileSettings.default_content && this.profileSettings.default_content.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
        return true;
      }
      return false;
    },
    AIQuestions () {
      if (this.profileSettings.default_chapters && this.profileSettings.default_chapters.length) {
        let chapterName = this.currentDocument.name;
        if (chapterName.indexOf('Parent 1') > -1) {
          chapterName = chapterName.replace('Parent 1', this.Account.name.split(" / ")[0]);
        } else if (chapterName.indexOf('Parent 2') > -1) {
          chapterName = chapterName.replace('Parent 2', this.Account.name.split(" / ")[1]);
        }
        let configIndex = this.profileSettings.default_chapters.findIndex(x => x.name === chapterName);
        if (configIndex > -1) {
          return this.profileSettings.default_chapters[configIndex].AIQuestions || [];
        } else {
          let configItem = this.profileSettings.default_chapters.find(x => x.name === 'new_chapters');
          if (configItem) {
            return configItem.AIQuestions || [];
          }
        }
      }
      return [];
    },
    cssVars () {
      return {
        '--v-tabs-bar-display': this.topTabsDisplay
      };
    },
    coachAvatar () {
      return this.ProfileDocument.writer && this.ProfileDocument.writer.avatar ? this.ProfileDocument.writer.avatar : '/static/profile-pic.jpg';
    },
    groupedChapterPhotos () {
      let datedPhotos = {};
      this.currentDocument.items.forEach(item => {
        if (item.submitted_date) {
          let date = item.submitted_date.substr(0, 10);
          if (!datedPhotos[date]) {
            datedPhotos[date] = [];
          }
          datedPhotos[date].push(item);
        } else {
          if (!datedPhotos['N/A']) {
            datedPhotos['N/A'] = [];
          }
          datedPhotos['N/A'].push(item);
        }
      });
      return datedPhotos;
    },
    isAllApproved () {
      let done = true;

      /* Content */
      if (!Object.keys(this.ProfileDocument).length) {
        return false;
      }
      this.ProfileDocument.chapters.forEach(chapter => {
        if (!chapter.content || !chapter.content.revision || !chapter.content.revision.length || chapter.content.status !== 'Approved') {
          done = false;
        }

        /* Chapter items */
        if (!chapter.items || !chapter.items.length) {
          done = false;
        }

        chapter.items.forEach(item => {
          if (!item || !item.photo || item.status !== 'Approved') {
            done = false;
          }
        });

      });

      /* Design */
      // if (!this.ProfileDocument.design || !this.ProfileDocument.design.template) {
      //   done = false;
      // }

      /* Covers */
      if (!this.ProfileDocument.special_pictures) {
        done = false;
      }
      if (!this.ProfileDocument.special_pictures.front_cover || !this.ProfileDocument.special_pictures.front_cover.photo || this.ProfileDocument.special_pictures.front_cover.status !== 'Approved') {
        done = false;
      }
      if (!this.ProfileDocument.special_pictures.center_spread || !this.ProfileDocument.special_pictures.center_spread.photo || this.ProfileDocument.special_pictures.center_spread.status !== 'Approved') {
        done = false;
      }
      if (!this.ProfileDocument.special_pictures.back_cover || !this.ProfileDocument.special_pictures.back_cover.photo || this.ProfileDocument.special_pictures.back_cover.status !== 'Approved') {
        done = false;
      }

      return done;

    },
    currentPDFStatus () {
      if (this.ProfileDocument.pdf && this.ProfileDocument.pdf.review_history && this.ProfileDocument.pdf.review_history.length && this.ProfileDocument.pdf.review_history[this.ProfileDocument.pdf.review_history.length - 1]) {
        return this.ProfileDocument.pdf.review_history[this.ProfileDocument.pdf.review_history.length - 1];
      }
      return null;
    }
  },
  async created() {

    this.accountDetails = JSON.parse(JSON.stringify(this.Account));
    await this.loadProfileSettings();
    await this.loadProfileDocument();

    this.scrollToTop();

    this.setSpecialPictures();
    await this.loadProfileAlbum();
    await this.loadAlbums();
    // await this.initializeHelpVideos();
    await this.loadFAQs();

    /* Set the design fields if not exists */
    // if (this.ProfileDocument.design) {
    //   this.design.template = this.ProfileDocument.design.template ? this.ProfileDocument.design.template : this.design.template;
    // }
    /* Disable the loading screen by default */
    window.getApp.$emit('BGProgress', true);

    this.showTours('PF.ProfileDoc.Template.Expired', 'templateTour');

  },
  beforeDestroy() {
    /* Enable the loading screen */
    window.getApp.$emit('BGProgress', false);
  },
  mounted() {
    // if (!this.hasMediatorListener) {
    window.getApp.$on('NEW_MESSAGE', messageEvent => {
      if (this.currentDocument && this.ProfileDocConversation[this.currentDocument._id] && messageEvent.data && messageEvent.data.length) {
        /* Get the chapter conversation and add the last message */
        let chapterConversation = messageEvent.data.find(x => x.profile_chapter);
        if (chapterConversation && chapterConversation.last_message) {
          if (!this.ProfileDocConversation[this.currentDocument._id].message) {
            this.ProfileDocConversation[this.currentDocument._id].message = [];
          }
          this.ProfileDocConversation[this.currentDocument._id].message.push({ message: chapterConversation.last_message });
          this.ProfileDocConversation = this.ProfileDocConversation;
        } 
      }
    });
    window.getApp.$on("NEW_ALBUM_PHOTO", async messageEvent => {
      this.isListEmpty = false;
      console.log("------------>>>>>>>", "Album Profile Images", messageEvent);
      if (messageEvent.data) {
        let albumId = messageEvent.data.album;
        let newImage = messageEvent.data;
        let existingImage = false;
        if (this.Account.avatar_album === albumId) {
          if (newImage.approved) {
            this.accountDetails.avatar = newImage.thumb_url;
          } else {
            this.accountDetails.temp_avatar = newImage.thumb_url;
          }
          store.commit("setAccount", this.accountDetails);
        } else if (this.Account.banner_album === albumId) {
          if (newImage.approved) {
            this.accountDetails.banner_photo = newImage.original_url;
          } else {
            this.accountDetails.temp_banner = newImage.original_url;
          }
          store.commit("setAccount", this.accountDetails);
        } else if (
          this.Account.mobile_banner_album &&
          this.Account.mobile_banner_album === albumId
        ) {
          if (newImage.approved) {
            this.accountDetails.mobile_banner = newImage.original_url;
          } else {
            this.accountDetails.temp_mobile_banner = newImage.original_url;
          }
          store.commit("setAccount", this.accountDetails);
        } else {
          /* Do only for the profile album */
          if (
            this.Account.profile_album &&
            this.Account.profile_album === albumId
          ) {
            /* Push to the album store first */
            if (!this.AlbumPhoto[albumId]) {
              this.AlbumPhoto[albumId] = [];
            }
            if (this.AlbumPhoto[albumId].length > 0) {
              if (
                this.AlbumPhoto[albumId].find(item => item.id === newImage.id)
              ) {
                existingImage = true;
              }
              if (!existingImage) {
                this.AlbumPhoto[albumId].push(newImage);
              }
            }
            /* Push to the ProfileDocument chapters */
            if (
              this.ProfileDocument.chapters &&
              this.ProfileDocument.chapters.length
            ) {
              /* Identify the chapter */
              let chapterName = null;
              let index = -1;
              let isKeyChapterIndex = -1;
              Object.keys(this.uploadData).forEach(key => {
                isKeyChapterIndex = this.ProfileDocument.chapters
                  .map(c => c.name)
                  .indexOf(key);
                index =
                  isKeyChapterIndex > -1
                    ? this.uploadData[key].indexOf(newImage.filename)
                    : -1;
                if (index > -1) {
                  chapterName = key;

                  /* Clear the file from uploadData */
                  this.uploadData[key].splice(index, 1);
                }
              });

              if (chapterName) {
                let uploadChapterIndex = this.ProfileDocument.chapters.findIndex(
                  x => x.name === chapterName
                );
                // eslint-disable-next-line
                if (uploadChapterIndex > -1) {
                  let sort = this.ProfileDocument.chapters[uploadChapterIndex]
                    .items.length;
                  let newmItem = {
                    type: "Photo",
                    photo: newImage,
                    sort: sort,
                    _id: newImage._id
                  };
                  // eslint-disable-next-line
                  if (
                    this.ProfileDocument.chapters[
                      uploadChapterIndex
                    ].items.findIndex(i => i.photo.id === newmItem.photo.id) ===
                    -1
                  ) {
                    this.ProfileDocument.chapters[
                      uploadChapterIndex
                    ].items.push(newmItem);
                    this.ProfileDocument = this.ProfileDocument;

                    /* Sleep for 1.5 seconds */
                    await sleep(1500);

                    /* Update the ProfileDocument collection */
                    await this.updateProfileDocument("upload");
                    this.layout();
                  }
                }
              } else {
                /* Check if the item is a special picture */
                let spacialPictures = [
                  "Front Cover",
                  "Back Cover",
                  "Center Spread"
                ];
                let specialType = null;
                spacialPictures.forEach(async s => {
                  specialType = "special_" + s.replace(" ", "").toLowerCase();
                  if (
                    this.uploadData[specialType] &&
                    newImage.filename.indexOf(specialType) > -1
                  ) {
                    let DBKey = s.replace(" ", "_").toLowerCase(); // front_cover, back_cover and center_spread
                    if (!this.ProfileDocument.special_pictures) {
                      this.ProfileDocument.special_pictures = {};
                    }
                    this.ProfileDocument.special_pictures[DBKey] = {
                      photo: newImage,
                      status: "Pending"
                    };
                    this.ProfileDocument = this.ProfileDocument;

                    /* Clear the file from uploadData */
                    delete this.uploadData[specialType];

                    /* Sleep for 1.5 seconds */
                    await sleep(1500);

                    /* Update the ProfileDocument collection */
                    await this.updateProfileDocument("upload");
                    this.setSpecialPictures();
                  }
                });
              }
            }
          }
        }
      }
    });
    // }
  },
  beforeRouteEnter(to, from, next) {
    if (!session.isOnline()) {
      next({ path: "/login" });
    } else {
      next();
    }
  },
  watch: {
    realCurrentContent: {
      handler: async function(newValue) {
        if (newValue) {
          await this.updateProfileDocument('content');
        }
      }
    },
    currentRevisionContent (newValue) {
      if (newValue && newValue.trim()) {
        let wordCount = this.currentChapterDefaults.content_word_count || 250;
        this.remainingWords = wordCount - newValue.trim().split(/\s+/).length;
        if (this.remainingWords < 0) {
          this.isWordsExceeded = true;
        }
      }
    }
  },
  methods: {
    showTours (section, name) {
      let vars = {
        'PF.ProfileDoc.Template.Expired': 'template',
        'PF.ProfileDoc.Chapters.Expired': 'chapters',
        'PF.ProfileDoc.Content.Expired': 'content',
        'PF.ProfileDoc.Photos.Expired': 'photos',
        'PF.ProfileDoc.Covers.Expired': 'covers',
      };
      if (section && name) {
        let item = global.localStorage.getItem(section);
        if (!item) {
          this.tours[vars[section]] = true;
          let self = this;
          setTimeout(() => {
            self.$tours[name].start();
          }, 100)
        }
      }
    },
    exitTour (type, variable) {
      global.localStorage.setItem(type, true);
      this.tours[variable] = false;
    },
    getOptions: function() {
      return {
        layoutMode: "masonry",
        masonry: {
          columnWidth: ".chapter-item",
          // gutter: 8
        },
        percentPosition: true,
        originLeft: true,
        itemSelector: ".chapter-item"
      };
    },
    layout() {
      // let keys = Object.keys(this.groupedChapterPhotos);
      // for (let date in this.groupedChapterPhotos) {
      //   let id = keys.indexOf(date);
      //   if (id > -1 && this.$refs['chapterImages_' + id]) {
      //     this.$refs['chapterImages_' + id][0].layout("masonry");
      //   }
      // }
      if (this.$refs.chapterImages) {
        this.$refs.chapterImages.layout("masonry");
      }
    },
    layoutAllPhotos() {
      if (this.$refs.profileAlbumImages) {
        this.$refs.profileAlbumImages.layout("masonry");
      }
    },
    layoutQualityPhotos() {
      if (this.$refs.profileQualityImages) {
        this.$refs.profileQualityImages.layout("masonry");
      }
    },
    layoutAlbums() {
      if (this.$refs.albumList) {
        this.$refs.albumList.layout("masonry");
      }
    },
    changeCurrentDoc(e, i = -1) {
      let chapter = null;
      let chapterIndex = -1;
      if (i > -1) {
        chapter = this.ProfileDocument.chapters[i];
        chapterIndex = i;
      } else if (e.target && e.target.value) {
        let index = this.ProfileDocument.chapters.findIndex(
          x => x.name === e.target.value
        );
        if (index > -1) {
          chapter = this.ProfileDocument.chapters[index];
          chapterIndex = index;
        }
      }
      if (chapter && chapterIndex > -1) {
        this.viewChapter(chapter, chapterIndex);
      }
    },
    async loadProfileDocument(force = false) {
      if (force || !Object.keys(this.ProfileDocument).length) {

        let entity = "ProfileDocument";
        let select = "filename mimetype size original_url thumb_url webview_url caption";
        let populate = [
          { path: "chapters.items.photo", select: select },
          { path: "writer", select: 'human avatar name' },
          { path: "special_pictures.front_cover.photo", select: select },
          { path: "special_pictures.back_cover.photo", select: select },
          { path: "special_pictures.center_spread.photo", select: select },
          { path: "pdf.template", select: 'file' }
        ];
        let where = { account: this.Account.id };
        let { error, data } = await getCollection(
          entity,
          true,
          0,
          populate,
          where
        );
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.ProfileDocument = data[0];

            /* Arrange based on sort value */
            if (
              this.ProfileDocument.chapters &&
              this.ProfileDocument.chapters.length
            ) {
              this.ProfileDocument.chapters.sort((a, b) => a.sort - b.sort);
              this.ProfileDocument = this.ProfileDocument;
            }

          } else {
            /* Create the document if not exists - affects the existing users */
            let newChapters = this.defaultChapters.length ? this.defaultChapters : [];
            if (!newChapters.length) {
              newChapters = [
                {
                  name: `Welcome`
                },
                {
                  name: `About ${
                    this.Account.account_type === "Couple" ? "Us" : "Me"
                  }`
                },
                {
                  name: `About ${this.Account.name.split(" / ")[0]}`
                },
                {
                  name: `${
                    this.Account.account_type === "Couple" ? "Our" : "My"
                  } Home`
                }
              ];
              if (this.Account.account_type === "Couple" && this.Account.name.split(" / ")[1]) {
                newChapters.splice(3, 0, {
                  name: `About ${this.Account.name.split(" / ")[1]}`
                });
              }
            }
            let payload = {
              account: this.Account.id,
              chapters: newChapters
            };
            /* Add sorting */
            payload.chapters = payload.chapters.map((chapter, i) => {
              chapter.sort = i;
              return chapter;
            });
            /* Call the create API */
            let { error, data } = await create("ProfileDocument", payload);
            if (error) {
              console.log("error", error);
            } else {
              this.ProfileDocument = data;
              /* Refresh to get the writer data */
              this.loadProfileDocument(true);

              swal.fire({
                type: "success",
                title: "Data loaded",
                text: "Your profile document data was loaded.",
                timer: 2500,
                onClose: () => {
                  return;
                }
              });
              return;
            }
          }
        }
      }
    },
    async loadProfileSettings() {
      let loaded = false;
      let chaptersFound = true;
      if (this.accountDetails.default_agency) {
        let { error, data } = await getOne('Agency', this.accountDetails.default_agency, '', 'profile_doc_settings');
        if (error) {
          console.log(error);
        } else {
          if (data && data.profile_doc_settings && Object.keys(data.profile_doc_settings)) {
            loaded = true;
            this.profileSettings = data.profile_doc_settings;
            if (!this.profileSettings.default_chapters || !this.profileSettings.default_chapters.length) {
              loaded = chaptersFound = false;
            }
          }
        }
      }
      if (!loaded) {
        let { error, data } = await getCollection('Agency', true, 0, '', { is_super_admin: true }, 'profile_doc_settings');
        if (error) {
          console.log(error);
        } else {
          if (data.length && data[0].profile_doc_settings && Object.keys(data[0].profile_doc_settings).length) {
            if (!chaptersFound) {
              this.profileSettings.default_chapters = data[0].profile_doc_settings.default_chapters ? data[0].profile_doc_settings.default_chapters : [];
            } else {
              this.profileSettings = data[0].profile_doc_settings;
            }
          }
        }
      }

      if (!this.profileSettings.max_chapters) {
        this.profileSettings.max_chapters = 10;
      }
      if (typeof this.profileSettings.back_cover_required === 'undefined') {
        this.profileSettings.back_cover_required = true;
      }
      if (typeof this.profileSettings.agency_approval_required === 'undefined') {
        this.profileSettings.agency_approval_required = false;
      }
      if (typeof this.profileSettings.center_spread_required === 'undefined') {
        this.profileSettings.center_spread_required = true;
      }
      /* if (!this.profileSettings.tips_text) {
        this.profileSettings.tips_text = `<h5 class="mb-2 font-weight-bold">Here are some tips to complete your profile documents.</h5><p class="font-italic">The tips goes here</p>`;
      } */
    },
    async loadConversation (isCoverConversations = false) {

      if ((this.currentDocument && this.currentDocument._id && !this.ProfileDocConversation[this.currentDocument._id]) || (isCoverConversations && !this.ProfileDocConversation[this.ProfileDocument._id])) {
        // this.loadingMessages = true;
        let sort = { 'updatedAt': -1 };
        let sessionUser = session.getSession();
        let where = {};
        where = {
          $and: [
            {
              $or: [
                {
                  human: sessionUser.user.human.id
                }
              ]
            },
            {
              $or: [
                {
                  archive: { $exists: false }
                },
                {
                  archive: {
                    $ne: sessionUser.user.human.id
                  }
                }
              ]
            },
            {
              $or: [
                {
                  removed: { $exists: false }
                },
                {
                  removed: {
                    $ne: sessionUser.user.human.id
                  }
                }
              ]
            }
          ]
        };

        if (isCoverConversations) {
          where.$and.push({ profile_cover: this.ProfileDocument._id });
        } else {
          where.$and.push({ profile_chapter: this.currentDocument._id });
        }

        if (sessionUser.user.human.group && sessionUser.user.human.group.length) {
          where.$and[0].$or.push({
            groups: {
              $in: sessionUser.user.human.group && sessionUser.user.human.group.length ? sessionUser.user.human.group.map(group => group.group) : []
            }
          });
        }
        let { error, data } = await getCollection('Conversation', true, 0, await conversationListPopulate(sessionUser.user.human.id), where, null, null, sort, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {

            if (isCoverConversations) {
              this.ProfileDocConversation[this.ProfileDocument._id] = data[0];
            } else {
              this.ProfileDocConversation[this.currentDocument._id] = data[0];
            }
            
            setTimeout(() => {
              const container = this.$el.querySelector('.ps-container.messages-conversation');
              container.scrollTop = container.scrollHeight;
              this.loadingMessages = false;
            }, 0);
            
          } else {
            this.loadingMessages = false;
          }
        }
      }
    },
    async createConversation (isCoverImage = false) {
      /* Create if writer human id exists */
      let conversation = {
        human: []
      };
      if (((this.currentDocument && this.currentDocument._id) || isCoverImage) && this.ProfileDocument.writer && this.ProfileDocument.writer.human && this.ProfileDocument.writer.human.length) {
        conversation.human.push(this.Account.human[0].id);
        conversation.human.push(this.ProfileDocument.writer.human[0]);

        if (isCoverImage) {
          conversation.profile_cover = this.ProfileDocument._id;
          conversation.subject = `Profile Covers Comments`;
        } else {
          conversation.profile_chapter = this.currentDocument._id;
          conversation.subject = `Chapter Comments - ${this.currentDocument.name}`;
        }

        let { error, data, status } = await create('Conversation', conversation);
        if (error) {
          console.log('error', error);
        } else {
          if (isCoverImage) {
            this.ProfileDocConversation[this.ProfileDocument._id] = data;
          } else {
            this.ProfileDocConversation[this.currentDocument._id] = data;
          }
          return true;
        }
      }
      return false;
    },
    async send (isSilent = false) {
      let isCover = false;
      /* Create conversation if not exists */
      if (this.currentDocument && (!this.currentDocument._id || !this.ProfileDocConversation[this.currentDocument._id])) {
        if (!await this.createConversation() && !isSilent) {
          swal.fire({
            type: 'warning',
            title: 'Failed',
            text: 'Failed to initiate the conversation, please try again',
            showConfirmButton: true,
            onClose: () => {}
          });
          return;
        }
      } else if (this.tabsModel === 'tab-3') {
        isCover = true;
        if (!this.ProfileDocConversation[this.ProfileDocument._id]) {
          /* Create the conversation for profile covers - identifier as the profile doc id */
          if (!await this.createConversation(isCover) && !isSilent) {
            swal.fire({
              type: 'warning',
              title: 'Failed',
              text: 'Failed to initiate the conversation, please try again',
              showConfirmButton: true,
              onClose: () => {}
            });
            return;
          }
        }
      }

      if (this.message.content && (this.currentDocument || isCover)) {

        let conversationIdentifier = isCover ? this.ProfileDocument._id : this.currentDocument._id;
        let chapterConversation = this.ProfileDocConversation[conversationIdentifier];
        this.message.conversation = chapterConversation.id;
        this.message.sender = this.Account.human[0].id;

        let { error, data, status } = await create('Message', this.message);
        if (error) {
          console.log('error', error);
        } else {

          let humanData = {
            account: {
              avatar: this.Account.avatar,
              id: this.Account.id,
              name: this.Account.name,
              ppn: this.Account.ppn,
              _id: this.Account._id
            },
            birth_date: this.Account.human[0].birth_date,
            id: this.Account.human[0].id,
            user: this.Account.human[0].user,
            _id: this.Account.human[0]._id
          };
          data.human = humanData;
          
          /* Update the state */
          if (!this.ProfileDocConversation[conversationIdentifier].message) {
            this.ProfileDocConversation[conversationIdentifier].message = [];
          }
          this.ProfileDocConversation[conversationIdentifier].message.push({ message: data });
          this.ProfileDocConversation[conversationIdentifier].last_message = data;
          this.message.content = '';

          if (!isSilent) {
            // swal.fire({
            //   type: 'success',
            //   title: 'Message sent successfully',
            //   timer: 2500,
            //   onClose: () => {
            //   }
            // });
  
            setTimeout(() => {
              const container = this.$el.querySelector('.ps-container.messages-conversation');
              container.scrollTop = container.scrollHeight;
            }, 0);
          }
        }
      }
    },
    setSpecialPictures() {
      if (
        Object.keys(this.ProfileDocument).length &&
        this.ProfileDocument.special_pictures
      ) {
        this.front_cover =
          this.ProfileDocument.special_pictures["front_cover"] &&
          this.ProfileDocument.special_pictures["front_cover"].photo &&
          this.ProfileDocument.special_pictures["front_cover"].photo
            .original_url
            ? (this.ProfileDocument.special_pictures[
                "front_cover"
              ].photo.original_url.indexOf("http") === -1
                ? config.s3BucketPath
                : "") +
              this.ProfileDocument.special_pictures["front_cover"].photo
                .original_url
            : this.front_cover;

        this.back_cover =
          this.ProfileDocument.special_pictures["back_cover"] &&
          this.ProfileDocument.special_pictures["back_cover"].photo &&
          this.ProfileDocument.special_pictures["back_cover"].photo.original_url
            ? (this.ProfileDocument.special_pictures[
                "back_cover"
              ].photo.original_url.indexOf("http") === -1
                ? config.s3BucketPath
                : "") +
              this.ProfileDocument.special_pictures["back_cover"].photo
                .original_url
            : this.back_cover;

        this.center_spread =
          this.ProfileDocument.special_pictures["center_spread"] &&
          this.ProfileDocument.special_pictures["center_spread"].photo &&
          this.ProfileDocument.special_pictures["center_spread"].photo
            .original_url
            ? (this.ProfileDocument.special_pictures[
                "center_spread"
              ].photo.original_url.indexOf("http") === -1
                ? config.s3BucketPath
                : "") +
              this.ProfileDocument.special_pictures["center_spread"].photo
                .original_url
            : this.center_spread;
      }
    },
    getSpecialPicture(key) {
      if (this[key]) {
        return this[key];
      }
      return null;
    },
    async loadAlbums () {
      if (!this.albumList.length) {
        let sessionUser = session.getSession();
        let where = {};
        if (sessionUser.adminUser) {
          where.account = sessionUser.user.human.account.id;
        }
        let populate = { path: 'photo.photo', select: 'filename mimetype size original_url thumb_url webview_url caption' };
        let { error, data } = await getCollection('Album', true, 0, populate, where);
        if (error) {
          console.log('error', error);
        } else {
          if (data.length > 0) {
            this.albumList = sortList('Album', data, 'Account', sessionUser.adminUser ? sessionUser.user.human.account.id : 'Me');
            await this.setUnassignedItems();
          }
        }
      }
    },
    async loadProfileAlbum() {
      if (this.Account && this.Account.profile_album) {
        let { error, data } = await getOne("Album", this.Account.profile_album);
        if (error) {
          console.log(error);
        } else {
          if (data) {
            this.profileAlbum = data;
          } else {
            await this.createProfileAlbum();
          }
        }
      } else {
        await this.createProfileAlbum();
      }
    },
    async createProfileAlbum() {
      /* Create profile album for the account */
      let albumDocument = {
        name: "Profile Images",
        type: "Profile",
        account: this.Account.id
      };
      let { error: albumError, data: albumData } = await create(
        "Album",
        albumDocument
      );
      if (albumError) {
        console.log(albumError);
      } else {
        this.Account.profile_album = albumData.id;
        this.Account.updated_from = "basic";
        this.profileAlbum = albumData;
        store.commit("setAccount", this.Account);

        /* Update the account */
        let { error: accountError, data: accountData } = await update(
          "Account",
          this.Account,
          this.Account.id
        );
        if (accountError) {
          console.log(accountError);
        }/*  else {
          swal.fire({
            type: "success",
            title: "Profile album created",
            text: "Profile album was created successfully",
            timer: 2500,
            onClose: () => {
              return;
            }
          });
          return;
        } */
      }
    },
    async selectPhoto(photo, toAdd = false) {
      /* Return if not yet submitted */
      if (!photo || photo.status === 'Approved' || this.ProfileDocument.submitted || (toAdd && (this.isAlreadyAssigned(photo) || this.isLowQualityImage(photo)))) {
        return;
      }
      
      /* 
        1. If selected from the photo list to add, add photo and auto save
        2. If selected from the existing list in photo add screen, remove photo and auto save
        3. If selected from the existing photos only screen, select multiple and proceed with the events
      */
      /* Add the photo to the currentDocument */
      let autoSave = false;
      if (toAdd) {
        autoSave = true;
        if (this.currentDocument.items && this.currentDocument.items.length >= this.currentChapterDefaults.max_chapter_photos) {
          swal.fire({
            type: 'warning',
            title: 'Limit Exceeded',
            text: `You can add only up to ${ this.currentChapterDefaults.max_chapter_photos } photos`,
            showConfirmButton: true,
            onClose: () => {}
          });
          return;
        }
        photo.status = 'Saved';
        this.currentDocument.items.push(photo);
      } else if (this.addingPhotos) {
        let index = this.currentDocument.items.findIndex(x => x.photo.id.toString() === photo.photo.id.toString());
        if (index > -1) {
          this.currentDocument.items.splice(index, 1);
          autoSave = true;
        }
      } else {
        /* Case #3 */
        if (photo && photo._id &&
          this.selectedPhotos.findIndex(x => x._id.toString() === photo._id.toString()) > -1) {
          this.selectedPhotos.splice(
            this.selectedPhotos.findIndex(x => x._id.toString() === photo._id.toString()),
            1
          );
        } else {
          this.selectedPhotos.push(photo);
        }
      }
      if (autoSave) {
        this.currentDocument = this.currentDocument;
        this.ProfileDocument.chapters[this.currentDocumentIndex] = this.currentDocument;
        await this.updateProfileDocument('addPhoto');
        this.setUnassignedItems();
      }

    },
    async removePhoto(photo) {
      if (!photo || photo.status === 'Approved' || this.ProfileDocument.submitted) {
        return;
      }
      
      let index = this.currentDocument.items.findIndex(x => x.photo.id.toString() === photo.photo.id.toString());
      if (index > -1) {
        this.currentDocument.items.splice(index, 1);
      }
      
      this.currentDocument = this.currentDocument;
      this.ProfileDocument.chapters[this.currentDocumentIndex] = this.currentDocument;
      await this.updateProfileDocument('unassign');
      this.setUnassignedItems();

    },
    closeAddPhotos() {
      this.selectedPhotos = [];
      this.addingPhotos = false;

      this.currentAlbum = null;
      this.currentAlbumIndex = -1;
      
      /* Trigger window resize to re-arrange the photos */
      window.dispatchEvent(new Event('resize'));
      
    },
    /* whereAmI () {
      this.showStatusPopup = true;
    }, */
    async initializeHelpVideos() {
      if (!this.helpVideoList.length) {
        if (typeof this.Account.membership !== "undefined") {
          let where = {
            membership: this.Account.membership,
            category: "Profile Layout"
          };
          let sort = { sort_no: 1 };
          let { error, data } = await getCollection(
            "HelpVideo",
            true,
            0,
            "",
            where,
            null,
            null,
            sort
          );
          if (error) {
            console.log(error);
          } else {
            if (data.length > 0) {
              /* Set the first one as the currentHelpVideo */
              this.currentHelpVideo = data[0];

              /* Fetch the vimeo thumbnails for each video */
              let videoJSON = null;
              let videoId = null;
              let video = null;
              for (let i = 0; i < data.length; i++) {
                video = data[i];
                videoId = video.url.substr(video.url.lastIndexOf("/") + 1);
                videoJSON = await getVimeoJSON(videoId);
                video.thumbnail =
                  videoJSON.data &&
                  videoJSON.data[0] &&
                  videoJSON.data[0].thumbnail_small
                    ? videoJSON.data[0].thumbnail_small
                    : null;
                data[i] = video;
              }
              this.helpVideoList = data;
            }
          }
        }
      }
    },
    async loadFAQs() {
      if (this.FAQList.length) {
        this.FAQ = this.FAQList.filter(x => x.category === 'Profile Layout')
      }
      if (!this.FAQ.length) {
        if (typeof this.Account.membership !== "undefined") {
          let where = {
            membership: this.Account.membership,
            category: "Profile Layout"
          };
          let sort = { title: 1 };
          let { error, data } = await getCollection(
            "FAQ",
            true,
            0,
            "",
            where,
            null,
            null,
            sort
          );
          if (error) {
            console.log(error);
          } else {
            if (data.length) {
              this.FAQ = data;
            }
          }
        }
      }
    },
    viewHelpVideo(video) {
      this.currentHelpVideo = video;
    },
    viewHelp() {
      this.isHelpScreen = true;
      this.currentDocument = null;
      this.currentDocumentIndex = -1;
    },
    backToListing() {
      this.closeAddPhotos();
      /* Show the main tabs */
      this.topTabsDisplay = 'block';
      this.currentDocument = null;
      this.currentDocumentIndex = -1;

      /* Hide the tips and comments */
      this.showComments = this.showTips = false;

      /* Close the help screen */
      this.isHelpScreen = false;

      /* Unset the current revision content */
      this.currentRevisionContent = '';

      /* Unset isWordsExceeded */
      this.isWordsExceeded = false;
    },

    getChapterStatus(doc) {
      let statuses = [];
      if (doc) {
        if (doc.content && doc.content.status) {
          statuses.push(doc.content.status);
        } else {
          statuses.push("Pending");
        }
        if (doc.items && doc.items.length) {
          doc.items.forEach(photo => {
            if (photo && photo.status) {
              statuses.push(photo.status);
            }
          });
        } else {
          statuses.push("Pending");
        }
        if (statuses.length) {
          if (statuses.indexOf("Suggestion") > -1) {
            return "Suggestion";
          } if (statuses.indexOf("AgencySuggestion") > -1) {
            return "AgencySuggestion";
          } else if (statuses.indexOf("Replace") > -1) {
            return "Replace";
          } else if (statuses.indexOf("Pending") > -1) {
            return "Pending";
          } else if (statuses.indexOf("Saved") > -1) {
            return "Saved";
          } else if (statuses.indexOf("Review") > -1) {
            return "Review";
          } else if (statuses.indexOf("WriterReview") > -1) {
            return "WriterReview";
          } else if (statuses.indexOf("AgencyReview") > -1) {
            return "AgencyReview";
          } else if (
            statuses.filter(x => x === "Approved").length === statuses.length &&
            statuses.length === doc.items.length + 1
          ) {
            return "Approved";
          } else {
            return "Pending";
          }
        }
      }
      return "Pending";
    },
    setNewContent () {
      if (this.currentRevisionContent) {
        this.currentDocument.content.revision[
          this.currentDocument.content.revision.length - 1
        ].text = this.currentRevisionContent;
        /* Set the content date Add the content to the payload */
        this.currentDocument.content.status = 'Saved';
        this.currentDocument.content.status_date = new Date().toISOString();
        this.ProfileDocument.chapters[
          this.currentDocumentIndex
        ] = this.currentDocument;
      }
    },
    async updateProfileDocument(requestFrom = "manual") {
      if (requestFrom === "content") {
        if (
          !this.currentRevisionContent ||
          !this.currentRevisionContent
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/\s/g, "").length
        ) {
          swal.fire({
            type: "warning",
            title: "Empty Content",
            text: "Please add the chapter content to save",
            showConfirmButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "OK"
          });
          return;
        } else {
          this.setNewContent();
        }
      }

      let entity = "ProfileDocument";

      /* Remove dummy chapters */
      this.ProfileDocument.chapters = this.ProfileDocument.chapters.filter(
        x => x.name
      );
      this.setDocumentStatuses();
      let updateData = JSON.parse(JSON.stringify(this.ProfileDocument));
      updateData = await this.formatProfileDocument(updateData);

      let isSubmit = false;
      let submitMessages = {};
      if (
        ["submitContent", "submitPhotos", "submitCover"].indexOf(requestFrom) >
        -1
      ) {
        isSubmit = true;
        submitMessages = {
          submitContent: "chapter content was",
          submitPhotos: "chapter photos were",
          submitCover: "cover pictures were"
        };
        updateData.submit_type = requestFrom;
      }
      if (requestFrom && requestFrom === 'pdfStatus') {
        updateData.request_from = requestFrom;
      }
      let { error, data } = await update(entity, updateData, updateData.id);
      if (error) {
        console.log(error);
      } else {
        /* Success message only for selected times */
        /* if (["content", "manual", "title"].indexOf(requestFrom) > -1) {
          swal.fire({
            type: "success",
            title: "Updated",
            text: "The profile document was updated.",
            timer: 2500
          });
        } else  */if (isSubmit) {
          /* swal.fire({
            type: "success",
            title: "Submitted",
            text: `The ${submitMessages[requestFrom]} successfully submitted for review, you'll be notified when it's done`,
            timer: 2500
          }); */
          this.backToListing();
        }
        /* Update the chapter schema id if new chapter was added */
        if (requestFrom === 'newChapter') {
          this.ProfileDocument.chapters[this.ProfileDocument.chapters.length - 1]._id = data.chapters[data.chapters.length - 1]._id;
          this.ProfileDocument = this.ProfileDocument;
        }
        return { error, data };
      }
    },
    async formatProfileDocument(data) {
      data.chapters = data.chapters.map(c => {
        c.items = c.items
          .filter(i => i.photo && i.photo.id)
          .map(i => {
            i.photo = i.photo.id;
            return i;
          });
        /* Set the content as object - init */
        if (c.content) {
          if (typeof c.content === "string") {
            c.content = {
              revision: [{ text: c.content, owner: "Parent", date: (new Date()).toISOString() }],
              status: "Saved"
            };
          }

          if (c.content && c.content.revision && c.content.revision.length) {
            /* Remove the revision if no text found */
            c.content.revision = c.content.revision.filter(rev => {
              return (
                rev.text &&
                rev.text.replace(/(<([^>]+)>)/gi, "").replace(/\s/g, "").length
              );
            });
          }

          let content =
            c.content &&
            c.content.revision &&
            c.content.revision.length &&
            c.content.revision[c.content.revision.length - 1].text
              ? c.content.revision[c.content.revision.length - 1].text
              : null;

          /* Change to saved if all done */
          if (
            content &&
            content.replace(/(<([^>]+)>)/gi, "").replace(/\s/g, "").length &&
            c.content.status === "Pending"
          ) {
            c.content.status = "Saved";
          }
        }
        return c;
      });
      /* Change the populated objects to IDs in special_pictures */
      if (data.special_pictures) {
        let specialKeys = Object.keys(data.special_pictures);
        if (specialKeys.length) {
          specialKeys.forEach(key => {
            if (
              data.special_pictures[key] &&
              data.special_pictures[key].photo
            ) {
              data.special_pictures[key].photo =
                data.special_pictures[key].photo.id;
            }
          });
        }
      }
      if (data.pdf && data.pdf.template && data.pdf.template.id) {
        data.pdf.template = data.pdf.template.id;
      }
      return data;
    },
    async setDocumentStatuses() {
      let data = JSON.parse(JSON.stringify(this.ProfileDocument));
      data.chapters = data.chapters.map(c => {
        /* Photos */
        c.items = c.items.map(i => {
          if (!i.status || i.status === "Pending") {
            i.status = "Saved";
          }
          return i;
        });

        /* Set the content as object - init */
        if (!c.content) {
          c.content = {
            revision: [{ text: "", owner: "Parent", date: (new Date()).toISOString() }],
            status: "Pending"
          };
        }
        let content =
          c.content &&
          c.content.revision &&
          c.content.revision.length &&
          c.content.revision[c.content.revision.length - 1].text
            ? c.content.revision[c.content.revision.length - 1].text
            : null;
        if (
          content &&
          content.replace(/(<([^>]+)>)/gi, "").replace(/\s/g, "").length &&
          c.content.status === "Pending"
        ) {
          c.content.status = "Saved";
        } else if (
          !content ||
          (!content.replace(/(<([^>]+)>)/gi, "").replace(/\s/g, "").length &&
            c.content.status !== "Pending")
        ) {
          c.content.status = "Pending";
        }
        return c;
      });

      if (data.special_pictures && Object.keys(data.special_pictures).length) {
        if (
          data.special_pictures.front_cover &&
          data.special_pictures.front_cover.photo &&
          data.special_pictures.front_cover.status === "Pending"
        ) {
          data.special_pictures.front_cover.status = "Saved";
        }
        if (
          data.special_pictures.center_spread &&
          data.special_pictures.center_spread.photo &&
          data.special_pictures.center_spread.status === "Pending"
        ) {
          data.special_pictures.center_spread.status = "Saved";
        }
        if (
          data.special_pictures.back_cover &&
          data.special_pictures.back_cover.photo &&
          data.special_pictures.back_cover.status === "Pending"
        ) {
          data.special_pictures.back_cover.status = "Saved";
        }
      }

      this.ProfileDocument = data;

      // if (this.currentDocumentIndex > -1 && this.currentDocument && !this.addingPhotos) {
      //   this.viewChapter(
      //     this.ProfileDocument.chapters[this.currentDocumentIndex],
      //     this.currentDocumentIndex
      //   );
      // }
    },
    addFromDefaultChapter () {
      if (this.ProfileDocument.submitted) {
        return;
      }

      if (this.ProfileDocument.chapters.length >= (this.profileSettings.max_chapters || 10)) {
        swal.fire({
          type: 'warning',
          title: 'Limit Exceeded',
          text: `You can only add maximum of ${ this.profileSettings.max_chapters || 10 } chapters`,
          showConfirmButton: true,
          onClose: () => {}
        });
        return;
      }
      /* Check if default chapters exists */
      this.unSelectedChapters = this.profileSettings.default_chapters.filter(x => x.name !== 'new_chapters' && [this.Account.account_type, 'Both'].indexOf(x.accountType) > -1 && this.ProfileDocument.chapters.findIndex(y => y.name === x.name) === -1);
      /* Filter out Parent 1 and Parent 2 */
      let parent1About = `About ${this.Account.name.split(" / ")[0]}`;
      let parent2About = `About ${this.Account.name.split(" / ")[1]}`;

      let parent1Index = this.ProfileDocument.chapters.findIndex(y => y.name === parent1About);
      let parent2Index = this.ProfileDocument.chapters.findIndex(y => y.name === parent2About);

      if (parent1Index > -1) {
        this.unSelectedChapters = this.unSelectedChapters.filter(x => x.name !== 'About Parent 1');
      } else {
        this.unSelectedChapters = this.unSelectedChapters.map(x => {
          if (x.name === 'About Parent 1') {
            x.name = `About ${this.Account.name.split(" / ")[0]}`;
          }
          return x;
        });
      }
      if (parent2Index > -1) {
        this.unSelectedChapters = this.unSelectedChapters.filter(x => x.name !== 'About Parent 2');
      } else {
        this.unSelectedChapters = this.unSelectedChapters.map(x => {
          if (x.name === 'About Parent 2') {
            x.name = `About ${this.Account.name.split(" / ")[1]}`;
          }
          return x;
        });
      }

      this.unSelectedChapters.push({
        name: 'Add A Custom Chapter',
        text: 'Add A Custom Chapter'
      });

      if (this.unSelectedChapters.length) {
        this.isAddFromDefaultChapters = true;
      }
    },
    handleAddChapter () {
      if (this.selectedNewChapter) {
        if (this.selectedNewChapter.name === 'Add A Custom Chapter') {
          this.closeAddChapter();
          this.addChapter();
        } else {
          let chapterName = this.selectedNewChapter.name;
          this.closeAddChapter();
          this.addChapter(chapterName);
        }
        // 
      }
    },
    closeAddChapter () {
      this.selectedNewChapter = null;
      this.isAddFromDefaultChapters = false;
    },
    async addChapter(chapterName = null) {
      // const { value: chapterName } = await swal.fire({
      //   title: "Enter the chapter name",
      //   input: "text",
      //   inputValue: "",
      //   showCancelButton: true,
      //   inputValidator: value => {
      //     if (!value) {
      //       return "You need to enter the chapter name";
      //     }
      //   }
      // });

      // if (this.ProfileDocument.submitted) {
      //   return;
      // }

      // if (this.ProfileDocument.chapters.length >= (this.profileSettings.max_chapters || 10)) {
      //   swal.fire({
      //     type: 'warning',
      //     title: 'Limit Exceeded',
      //     text: `You can only add maximum of ${ this.profileSettings.max_chapters || 10 } chapters`,
      //     showConfirmButton: true,
      //     onClose: () => {}
      //   });
      //   return;
      // }

      chapterName = chapterName ? chapterName : 'New Chapter';
      let newContent = this.profileSettings.default_content && this.profileSettings.default_content.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length ? this.profileSettings.default_content : null;

      if (chapterName) {
        let newChapter = {
          name: chapterName,
          items: [],
          sort: this.ProfileDocument.chapters.length
        };
        if (newContent) {
          newChapter.content = { revision: [{ text: newContent, owner: 'Parent', date: (new Date()).toISOString() }], status: 'Saved', status_date: (new Date()).toISOString() };
        }
        this.ProfileDocument.chapters.push(newChapter);
        await this.updateProfileDocument('newChapter');

        /* Open the chapter and enable the title edit */
        this.viewChapter(newChapter, this.ProfileDocument.chapters.length - 1);
        this.editChapterTitle();
        this.scrollToTop();
      }
    },
    scrollToTop () {

      /* Scroll to the top */
      window.getApp.$vuetify.goTo(document.getElementById('pageHeader').offsetTop - 70);

    },
    scrollToTabTop (elementId) {

      /* Scroll to the top */
      window.getApp.$vuetify.goTo(document.getElementById(elementId).offsetTop);

    },
    contentChanged(event, editor) {
      if (
        this.currentRevisionContent &&
        this.currentRevisionContent
          .replace(/(<([^>]+)>)/gi, "")
          .replace(/\s/g, "").length
      ) {
        let wordCount = this.currentChapterDefaults.content_word_count || 250;
        if (editor && editor.plugins && editor.plugins.wordcount && editor.plugins.wordcount.body.getWordCount() > wordCount) {
          this.remainingWords = wordCount - editor.plugins.wordcount.body.getWordCount();
          this.isWordsExceeded = true;

          /* Highlight the extra words */
          // let plainText = editor.getContent({ format: 'text' });
          // let words = plainText.trim().split(/\s+/);
          // let validText = words.slice(0, (this.profileSettings.content_word_count || 250));
          // validText = validText.join(' ');
          // let invalidText = words.slice((this.profileSettings.content_word_count || 250), words.length);
          // invalidText = invalidText.join(' ');
          // invalidText = `<span class="red">${invalidText}</span>`;
          // editor.setContent(validText + invalidText);
          
          return;
        } else {
          this.remainingWords = wordCount - editor.plugins.wordcount.body.getWordCount();
          this.isWordsExceeded = false;
          this.realCurrentContent = this.currentRevisionContent;
        }
      }
    },
    contentEditorKeyUp(event, editor) {
      this.isManualContent = true;
      this.contentChanged(event, editor);
    },
    viewChapter(chapter, chapterIndex) {
      /* Reset the panels */
      this.closeAddPhotos();

      /* Hide the tips and comments */
      this.showComments = this.showTips = false;

      /* Unset the isCaptionsMissing */
      this.isCaptionsMissing = false;

      /* Set the default tab as content */
      this.chapterTabs = 'tab-1'; // Content

      /* Set the currentDocument */
      this.currentDocument = chapter;
      this.currentDocumentIndex = chapterIndex;

      /* Set the currentTipsText */
      this.setCurrentTipsText();

      /* Set the currentChapterDefaults */
      this.setCurrentChapterDefaults();

      /* Set the words left */
      this.remainingWords = this.currentChapterDefaults.content_word_count;
      
      if (typeof this.currentChapterDefaults.max_chapter_photos === 'undefined') {
        this.currentChapterDefaults.max_chapter_photos = 10;
      }
      if (typeof this.currentChapterDefaults.content_word_count === 'undefined') {
        this.currentChapterDefaults.content_word_count = 250;
      }

      this.isManualContent = false;

      /* Scroll to the top */
      this.scrollToTabTop('chapter-content-tabs');

      /* Hide the main tabs */
      this.topTabsDisplay = 'none';

      if (
        this.currentDocument.content &&
        this.currentDocument.content.revision &&
        this.currentDocument.content.revision.length
      ) {
        /* Remove the last revision if status is WriterReview */
        if (this.currentDocument.content.status === 'WriterReview') {
          this.currentDocument.content.revision.pop();
          this.currentDocument.content.status = 'Review';
        }
        let revisionLength = this.currentDocument.content.revision.length;
        this.currentRevisionContent =
          this.currentDocument.content.revision[revisionLength - 1] &&
          this.currentDocument.content.revision[revisionLength - 1].text
            ? this.currentDocument.content.revision[revisionLength - 1].text
            : '';
      } else {
        this.currentDocument.content = {
          revision: [{ text: "", owner: "Parent", date: (new Date()).toISOString() }],
          status: "Pending"
        };
        this.currentRevisionContent = '';
      }

      /* Photo layout */
      // this.layout();

      /* Load the chapter conversations */
      this.loadConversation();

      // this.enableContentSave = false;

      // /* Set the unassigned items */
      // this.setUnassignedItems();

      /* Reset the selectedPhotos */
      this.selectedPhotos = [];

      /* Set the active content revision */
      if (this.currentDocument.content && this.currentDocument.content.revision && this.currentDocument.content.revision.length) {
        this.contentsModel = `tab-${this.currentDocument.content.revision.length}`;
      }

      /* Start the tour */
      this.showTours('PF.ProfileDoc.Content.Expired', 'contentTour');

    },

    goToNextStep (step) {

      if (step) {
        this.tabsModel = `tab-${step}`;
        this.scrollToTabTop('top-tabs');
      }

    },

    setCurrentTipsText () {
      if (!this.profileSettings || !this.profileSettings.default_chapters) {
        return;
      }
      let currChapterName = this.currentDocument.name;
      let defaultChapterIndex = this.profileSettings.default_chapters.findIndex(x => x.name === currChapterName);
      if (defaultChapterIndex > -1) {
        if (this.profileSettings.default_chapters[defaultChapterIndex] && this.profileSettings.default_chapters[defaultChapterIndex].tips) {
          this.currentTipsText = this.profileSettings.default_chapters[defaultChapterIndex].tips;
        }
      } else {
        currChapterName = currChapterName === 'About Me' ? 'About Us' : currChapterName;
        currChapterName = currChapterName === 'My Home' ? 'Our Home' : currChapterName;
        currChapterName = currChapterName === `About ${this.Account.name.split(' / ')[0]}` ? 'About Parent 1' : currChapterName;
        currChapterName = this.Account.account_type === 'Couple' && this.Account.name.split(' / ')[1] && currChapterName === `About ${this.Account.name.split(' / ')[1]}` ? 'About Parent 2' : currChapterName;
        defaultChapterIndex = this.profileSettings.default_chapters.findIndex(x => x.name === currChapterName);
        if (defaultChapterIndex > -1 && this.profileSettings.default_chapters[defaultChapterIndex] && this.profileSettings.default_chapters[defaultChapterIndex].tips) {
          this.currentTipsText = this.profileSettings.default_chapters[defaultChapterIndex].tips;
        } else if (this.profileSettings.tips_text && this.profileSettings.tips_text.new_chapters) {
          this.currentTipsText = this.profileSettings.tips_text.new_chapters;
        }
      }
    },

    setCurrentChapterDefaults () {
      if (this.currentDocument) {
        let defaultIndex = this.profileSettings.default_chapters.findIndex(x => x.name === this.currentDocument.name);
        if (defaultIndex === -1) {
          if (this.currentDocument.name === `About ${this.Account.name.split(" / ")[0]}`) {
            defaultIndex = this.profileSettings.default_chapters.findIndex(x => x.name === 'About Parent 1');
          } else if (this.currentDocument.name === `About ${this.Account.name.split(" / ")[1]}`) {
            defaultIndex = this.profileSettings.default_chapters.findIndex(x => x.name === 'About Parent 2');
          }
        }
        if (defaultIndex === -1) {
          defaultIndex = this.profileSettings.default_chapters.findIndex(x => x.name === 'new_chapters');
        }
        if (defaultIndex > -1) {
          this.currentChapterDefaults = this.profileSettings.default_chapters[defaultIndex] || {};
        }
      }
    },

    selectPhotos(chapter = null, chapterIndex = -1) {
      if (chapter && chapterIndex > -1) {
        this.viewChapter(chapter, chapterIndex);
        this.chapterTabs = 'tab-2'; // Photos
      }

      /* Hide the tips and comments */
      this.showComments = this.showTips = false;

      /* Set the unassigned items */
      this.setUnassignedItems();

      this.selectedPhotos = [];
      this.addingPhotos = true;
      
      /* Trigger window resize to re-arrange the photos */
      window.dispatchEvent(new Event('resize'));

      /* Start the tour */
      this.showTours('PF.ProfileDoc.Photos.Expired', 'photosTour');

    },
    async sortChapters() {
      this.ProfileDocument.chapters = this.ProfileDocument.chapters.map(
        (chapter, i) => {
          chapter.sort = i;
          return chapter;
        }
      );
      this.ProfileDocument = this.ProfileDocument;
      /* Update the DB */
      await this.updateProfileDocument();
    },
    async sortChapterItems() {
      this.currentDocument.items = this.currentDocument.items.map((item, i) => {
        item.sort = i;
        return item;
      });
      this.ProfileDocument.chapters[
        this.currentDocumentIndex
      ] = this.currentDocument;
      this.ProfileDocument = this.ProfileDocument;
      /* Update the DB */
      await this.updateProfileDocument();
    },
    addImage(uploadTo = "chapter", type = null) {
      const client = global.filestack.init(this.config.filestack.client);
      const humanId = session.user().human.id;
      let albumId = this.Account.profile_album
        ? this.Account.profile_album
        : null;
      let specialType = type
        ? "special_" + type.replace(" ", "").toLowerCase()
        : null;
      if (!albumId) {
        swal.fire({
          title: "Album not found",
          text: "The profile album is not found, please check with your agency",
          type: "warning"
        });
        return;
      }
      const options = {
        fromSources: ["local_file_system"],
        maxFiles: 20,
        accept: ["image/jpeg", "image/jpg", "image/png", "image/gif"],
        uploadInBackground: false,
        storeTo: {
          location: "S3",
          path:
            "/" +
            this.config.s3Domain +
            "/" +
            humanId +
            "/album/" +
            albumId +
            "/original/",
          access: "public"
        },
        onFileSelected(file) {
          if (file.size < config.imageQuality) {
            swal.fire({
              type: 'warning',
              title: 'Too Small',
              text: `File(s) too small, photos should have a minimum size of ${(config.imageQuality / 1024 / 1024)} MB`,
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {}
            });
            throw new Error( `File(s) too small, photos should have a minimum size of ${(config.imageQuality / 1024 / 1024)} MB`);
          }
          let filenameArr = file.filename.split(".");
          let ext = filenameArr.pop();
          let filename = filenameArr.join(".");
          filename = filename.replace(/[^0-9a-z]/gi, "");
          filename = specialType ? filename + "_" + specialType : filename;
          return { name: filename + "_" + new Date().getTime() + "." + ext };
        },
        onFileUploadFinished: response => {
          let filename = response.key.substr(response.key.lastIndexOf("/") + 1);
          if (uploadTo === "special" && specialType) {
            this.uploadData[specialType] = filename;
          } else {
            if (this.uploadData[this.currentDocument.name]) {
              this.uploadData[this.currentDocument.name].push(filename);
            } else {
              this.uploadData[this.currentDocument.name] = [filename];
            }
          }
          this.closeAddPhotos();
        }
        /* onUploadDone: (response) => {
          let filename = null;
          response.filesUploaded.forEach(f => {
            filename = f.key.substr(f.key.lastIndexOf('/') + 1);
            if (uploadTo === 'special' && specialType) {

              this.uploadData[specialType] = filename;
              
            } else {
              if (this.uploadData[this.currentDocument.name]) {
                this.uploadData[this.currentDocument.name].push(filename);
              } else {
                this.uploadData[this.currentDocument.name] = [filename];
              }
            }
          });
        } */
      };
      if (uploadTo === "special") {
        options.maxFiles = 1;
        if (type === "Center Spread") {
          options.transformations = {
            crop: { aspectRatio: 1152 / 720, force: true }
          };
          // options.imageMin = [1152, 720];
          // options.imageMax = [1152, 720];
        } else {
          options.transformations = {
            crop: { aspectRatio: 576 / 720, force: true }
          };
          // options.imageMin = [576, 720];
          // options.imageMax = [576, 720];
        }
      }
      client.picker(options).open();
    },
    deleteChapter(chapter = null) {
      if (!this.currentDocument || this.currentDocumentIndex === -1) {
        return false;
      }
      swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(async result => {
          if (result.value) {
            // this.ProfileDocument.chapters = this.ProfileDocument.chapters.filter(
            //   x => x.name !== chapter.name
            // );
            this.ProfileDocument.chapters.splice(this.currentDocumentIndex, 1)
            await this.updateProfileDocument();
            this.backToListing();
            return;
          }
        });
    },
    removePhotoCaptionEdit() {
      this.currentEditPhotoIndex = -1;
      this.currentEditPhoto = null;
      this.isEdit = false;
      this.editPhotoItem = null;
    },
    async unAssignSelectedPhotos() {
      this.selectedPhotos.forEach(item => {
        let itemIndex = this.currentDocument.items.findIndex(
          x => x._id.toString() === item._id.toString()
        );
        if (itemIndex > -1) {
          this.currentDocument.items.splice(itemIndex, 1);
        }
      });
      /* Reset the selestedPhotos */
      this.selectedPhotos = [];

      /* Set the ProfileDocument */
      this.ProfileDocument.chapters[
        this.currentDocumentIndex
      ] = this.currentDocument;
      this.ProfileDocument = this.ProfileDocument;
      /* Update the DB */
      await this.updateProfileDocument("unassign");
    },
    
    // async deleteItem(item) {
    //   if (item.photo && item.photo.id) {
    //     swal
    //       .fire({
    //         title: "Are you sure?",
    //         text: "You won't be able to revert this!",
    //         type: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#3085d6",
    //         cancelButtonColor: "#d33",
    //         confirmButtonText: "Yes, delete it!"
    //       })
    //       .then(result => {
    //         if (result.value) {
    //           (async () => {
    //             let { error, data, status } = await remove(
    //               "Photo",
    //               item.photo.id
    //             );
    //             if (error) {
    //               console.log("error", error);
    //             } else {
    //               /* Delete the photo from the profileAlbum */
    //               this.profileAlbum.photo.splice(
    //                 this.profileAlbum.photo.findIndex(
    //                   photo => photo.photo.id === item.photo.id
    //                 ),
    //                 1
    //               );

    //               swal.fire({
    //                 type: "success",
    //                 title: "Deleted!",
    //                 text: "Photo has been deleted.",
    //                 timer: 2500,
    //                 onClose: () => {
    //                   //
    //                 }
    //               });

    //               /* Update the unassigned items */
    //               await this.setUnassignedItems();
    //             }
    //           })();
    //         }
    //       });
    //   }
    // },
    
    async assignSelectedPhotos() {
      if (this.selectedPhotos.length) {
        this.currentDocument.items = [
          ...this.currentDocument.items,
          ...this.selectedPhotos
        ];
      }

      /* Set the ProfileDocument */
      this.ProfileDocument.chapters[
        this.currentDocumentIndex
      ] = this.currentDocument;
      this.ProfileDocument = this.ProfileDocument;

      this.selectedPhotos = [];

      /* Switch back to the album listing tab */
      if (this.currentAlbum) {
        this.backFromPhotos();
      }

      /* Update the DB */
      await this.updateProfileDocument();

      /* Update the unassigned items */
      await this.setUnassignedItems();
    },
    clearSelectedPhotos() {
      if (this.selectedPhotos.length) {
        this.selectedPhotos = [];
      }
    },
    async setUnassignedItems() {
      let assignedPhotoIds = [];
      this.unassignedItems = [];

      /* Special pictures IDs */
      let specialPictureIds = this.ProfileDocument.special_pictures &&
        Object.keys(this.ProfileDocument.special_pictures).length
          ? Object.keys(this.ProfileDocument.special_pictures)
              .filter(
                x =>
                  this.ProfileDocument.special_pictures[x] &&
                  this.ProfileDocument.special_pictures[x].photo &&
                  this.ProfileDocument.special_pictures[x].photo.id
              )
              .map(x => this.ProfileDocument.special_pictures[x].photo.id)
          : [];
      assignedPhotoIds = assignedPhotoIds.concat(specialPictureIds);
      
      for (let i = 0; i < this.albumList.length; i++) {
        let album = this.albumList[i];
        if (
          album &&
          album.photo &&
          album.photo.length
        ) {

          assignedPhotoIds = assignedPhotoIds.concat(Array.from(
            this.ProfileDocument.chapters.filter(c => c.items && c.items.length),
            chapter =>
              chapter.items
                .filter(i => i.photo && i.photo.id)
                .map(item => item.photo.id)
            )
            .join()
            .split(",")
          );
          
          this.unassignedItems = this.unassignedItems.concat(album.photo
            .filter(photo => assignedPhotoIds.indexOf(photo.photo.id) === -1)
            .map(photo => {
              return {
                photo: {
                  filename: photo.photo.filename,
                  mimetype: photo.photo.mimetype,
                  size: photo.photo.size,
                  thumb_url: photo.photo.thumb_url,
                  webview_url: photo.photo.webview_url,
                  original_url: photo.photo.original_url,
                  caption: photo.photo.caption,
                  id: photo.photo.id
                },
                type: "Photo",
                _id: photo._id
              };
            })
          );
        }
      }
    },
    isAlreadyAssigned(photo) {
      if (
        photo &&
        this.unassignedItems &&
        this.unassignedItems.length
      ) {
        let index = this.unassignedItems.findIndex(x => x.photo.id.toString() === photo.photo.id.toString());
        return index === -1;
      }
      return false;
    },

    isLowQualityImage(photo) {
      return (
        photo &&
        photo.photo &&
        photo.photo.size &&
        photo.photo.size <= config.imageQuality
      );
    },

    async submitContent() {
      if (!this.accountDetails || !this.accountDetails.default_agency) {
        swal.fire({
          type: "warning",
          title: "No default agency found",
          text: "Please set your default agency and try again.",
          timer: 2500,
          onClose: () => {
            return;
          }
        });
        return;
      }
      swal
        .fire({
          title: "Are you sure?",
          text: "Have you finished adding the content for this chapter?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, submit it!"
        })
        .then(async result => {
          if (result.value) {
            if (this.currentDocument) {
              /* Set the content if not yet clicked on save button */
              // if (this.enableContentSave) {
              //   this.setNewContent();
              // }
              /* Check if all ready for review */
              if (!(await this.validateData("content"))) {
                swal.fire({
                  type: "warning",
                  title: "Incomplete",
                  text: "Please make sure you added the chapter content",
                  timer: 2500,
                  onClose: () => {
                    return;
                  }
                });
                return;
              }

              /* Make all the status into Review if not yet Approved */
              if (this.currentDocument.content.status !== "Approved") {
                this.currentDocument.content.status = "Review";
                this.currentDocument.content.status_date = new Date().toISOString();
              }

              this.ProfileDocument.chapters[
                this.currentDocumentIndex
              ] = this.currentDocument;
              this.ProfileDocument = this.ProfileDocument;

              await this.updateProfileDocument("submitContent");
            }
          }
        });
    },

    openWritingAssistance () {

      if (this.AIQuestions && this.AIQuestions.length) {
        this.writingAssistantActive = true;
      } else {
        this.getWritingAssistance();
      }
    },

    submitAIAnswers (AIAnswers) {
      if (AIAnswers && AIAnswers.length) {
        this.getWritingAssistance(AIAnswers.filter(x => x && x.trim() && x.trim().length));
      } else {
        this.getWritingAssistance();
      }
    },

    async correctContentGrammar () {

      const rivision = this.currentDocument.content.revision;
      const content = rivision[rivision.length - 1];
        
      let payload = {
        prompt: content.text,
        agency: this.accountDetails.default_agency
      };

      window.getApp.$emit('BGProgress', false);
      window.getApp.$emit('LoadingText', 'Processing your chapter content');
      let { error, data } = await request('ProfileDocument/OpenAI/CorrectTextGrammar', 'POST', payload);
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to process the text'
        };
      } else {
        if (data.length) {
          this.currentRevisionContent = data[0].text;
          this.realCurrentContent = this.currentRevisionContent;
          swal.fire({
            type: "success",
            title: "Text Loaded",
            text: `We've processed and loaded the corrected data.`,
            showConfirmButton: true
          });
        }
      }
      window.getApp.$emit('BGProgress', true);
      window.getApp.$emit('LoadingText', 'Loading');

    },

    async getWritingAssistance (AIAnswers = null) {

      const rivision = this.currentDocument.content.revision;
      
      if ((!rivision.length && this.currentDocument.content.status === 'Pending') || (rivision.length === 1 && rivision[rivision.length - 1].owner === 'Parent' && ['Saved', 'Pending'].indexOf(this.currentDocument.content.status) > -1)) {
        // && (!this.profileSettings.default_content || (this.profileSettings.default_content && !this.profileSettings.default_content.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length))

        let chapterName = this.currentDocument.name;
        let payload = {
          prompt: chapterName
        };
        if (AIAnswers && AIAnswers.length) {
          payload.prompt = AIAnswers.join('\n');
        }
        payload.agency = this.accountDetails.default_agency;
        if (chapterName === `About ${this.Account.name.split(" / ")[0]}`) {
          payload.chapter = 'About Parent 1';
        } else if (chapterName === `About ${this.Account.name.split(" / ")[1]}`) {
          payload.chapter = 'About Parent 2';
        } else if (this.profileSettings.default_chapters.findIndex(x => x.name === chapterName) === -1) {
          payload.chapter = 'new_chapters';
        }

        window.getApp.$emit('BGProgress', false);
        window.getApp.$emit('LoadingText', 'Requesting text from writing assistant');
        let { error, data } = await request('ProfileDocument/OpenAI/TextonPrompt', 'POST', payload);
        if (error) {
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to get the writing assistance'
          };
        } else {
          if (data.length) {
            this.writingAssistantActive = false;
            this.currentRevisionContent = data[0].text;
            this.realCurrentContent = this.currentRevisionContent;
            swal.fire({
              type: "success",
              title: "Text Loaded",
              text: `Writing assistant loaded some text on the chapter. You can update it or retry for new text before submitting it`,
              showConfirmButton: true
            });
          }
        }
        window.getApp.$emit('BGProgress', true);
        window.getApp.$emit('LoadingText', 'Loading');
      }

    },

    async unSubmitContent() {
      if (!this.accountDetails || !this.accountDetails.default_agency) {
        swal.fire({
          type: "warning",
          title: "No default agency found",
          text: "Please set your default agency and try again.",
          timer: 2500,
          onClose: () => {
            return;
          }
        });
        return;
      }
      swal
        .fire({
          title: "Are you sure?",
          text: "Do you want to unsubmit the content for this chapter?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, unsubmit it!"
        })
        .then(async result => {
          if (result.value) {
            if (this.currentDocument) {
              if (this.currentDocument.content.status === "Review") {
                this.currentDocument.content.status = "Saved";
                this.currentDocument.content.status_date = new Date().toISOString();
              }

              this.ProfileDocument.chapters[
                this.currentDocumentIndex
              ] = this.currentDocument;
              this.ProfileDocument = this.ProfileDocument;

              await this.updateProfileDocument("unSubmitContent");
            }
          }
        });
    },
    async submitPhotos() {
      if (!this.accountDetails || !this.accountDetails.default_agency) {
        swal.fire({
          type: "warning",
          title: "No default agency found",
          text: "Please set your default agency and try again.",
          timer: 2500,
          onClose: () => {
            return;
          }
        });
        return;
      }

      /* Check if all the photo has caption */
      if (this.currentDocument.items.filter(x => !x.photo || !x.photo.caption || !x.photo.caption.trim()).length) {
        this.isCaptionsMissing = true;
        swal.fire({
          type: "warning",
          title: "No caption",
          text: "Please add captions to all photos before submit",
          timer: 2500
        });
        return;
      }

      swal
        .fire({
          title: "Are you sure?",
          text: "Have you finished adding the photos for this chapter?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, submit it!"
        })
        .then(async result => {
          if (result.value) {
            if (this.currentDocument) {
              /* Check if all ready for review */
              if (!(await this.validateData("photos"))) {
                swal.fire({
                  type: "warning",
                  title: "Incomplete",
                  text:
                    "Please make sure you added the photos to this chapter content",
                  timer: 2500,
                  onClose: () => {
                    return;
                  }
                });
                return;
              }

              /* Make all the status into Review if not yet Approved */
              this.currentDocument.items = this.currentDocument.items.map(x => {
                if (x.status !== "Approved") {
                  x.status = "Review";
                  x.submitted_date = new Date().toISOString();
                }
                return x;
              });

              this.ProfileDocument.chapters[
                this.currentDocumentIndex
              ] = this.currentDocument;
              this.ProfileDocument = this.ProfileDocument;

              await this.updateProfileDocument("submitPhotos");
            }
          }
        });
    },
    async submitCovers() {
      if (!this.accountDetails || !this.accountDetails.default_agency) {
        swal.fire({
          type: "warning",
          title: "No default agency found",
          text: "Please set your default agency and try again.",
          timer: 2500,
          onClose: () => {
            return;
          }
        });
        return;
      }

      swal
        .fire({
          title: "Are you sure?",
          text:
            "Do you want to submit the cover pictures and center spread ?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, submit it!"
        })
        .then(async result => {
          if (result.value) {
            if (this.ProfileDocument) {
              /* Check if all ready for review */
              if (!(await this.validateSpecialPictures())) {
                swal.fire({
                  type: "warning",
                  title: "Incomplete",
                  text:
                    "Please make sure you added the front cover, back cover and center spread pictures",
                  timer: 2500,
                  onClose: () => {
                    return;
                  }
                });
                return;
              }

              /* Make all the status into Review if not yet Approved */
              if (this.ProfileDocument.special_pictures.front_cover && this.ProfileDocument.special_pictures.front_cover.status !== "Approved") {
                this.ProfileDocument.special_pictures.front_cover.status = "Review";
                this.ProfileDocument.special_pictures.front_cover.status_date = new Date().toISOString();
              }
              if (this.ProfileDocument.special_pictures.back_cover && this.ProfileDocument.special_pictures.back_cover.status !== "Approved") {
                this.ProfileDocument.special_pictures.back_cover.status = "Review";
                this.ProfileDocument.special_pictures.back_cover.status_date = new Date().toISOString();
              }
              if (this.ProfileDocument.special_pictures.center_spread && this.ProfileDocument.special_pictures.center_spread.status !== "Approved") {
                this.ProfileDocument.special_pictures.center_spread.status = "Review";
                this.ProfileDocument.special_pictures.center_spread.status_date = new Date().toISOString();
              }

              this.ProfileDocument = this.ProfileDocument;

              await this.updateProfileDocument("submitCover");
            }
          }
        });
    },

    // async validateDocument () {

    //   let isReady = true;
    //   this.ProfileDocument.chapters.forEach(c => {
    //     if (!c.content || !c.content.text || !c.content.text.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
    //       isReady = false;
    //     }
    //     if (!c.items || !c.items.length || c.items.filter(x => x.photo && x.status && x.status === 'Pending').length) {
    //       isReady = false;
    //     }
    //     if (!c.status || c.status === 'Pending') {
    //       isReady = false;
    //     }
    //   });

    //   if (!this.ProfileDocument.special_pictures || !Object.keys(this.ProfileDocument.special_pictures).length) {
    //     isReady = false;
    //   }

    //   for (let i in this.ProfileDocument.special_pictures) {
    //     if (!this.ProfileDocument.special_pictures[i] || !this.ProfileDocument.special_pictures[i].photo || !this.ProfileDocument.special_pictures[i].status || this.ProfileDocument.special_pictures[i].status === 'Pending') {
    //       if (i === '_id') {
    //         continue;
    //       }
    //       isReady = false;
    //     }
    //   }
    //   return isReady;
    // },

    // async validateCurrentChapter () {

    //   let isReady = true;
    //   let doc = this.currentDocument;

    //   if (!doc.content || !doc.content.text || !doc.content.text.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
    //     isReady = false;
    //   }
    //   if (!doc.items || !doc.items.length) {
    //     isReady = false;
    //   }
    //   return isReady;

    // },

    async validateSpecialPictures() {
      let isReady = true;

      if (
        !this.ProfileDocument.special_pictures ||
        !Object.keys(this.ProfileDocument.special_pictures).length
      ) {
        isReady = false;
      }

      for (let i in this.ProfileDocument.special_pictures) {
        if (i === "_id") {
          continue;
        }
        let required = true;
        if (i === 'back_cover') {
          required = this.profileSettings.back_cover_required; 
        } else if (i === 'center_spread') {
          required = this.profileSettings.center_spread_required; 
        }

        if ( required &&
          (!this.ProfileDocument.special_pictures[i] ||
          !this.ProfileDocument.special_pictures[i].photo ||
          !this.ProfileDocument.special_pictures[i].status ||
          this.ProfileDocument.special_pictures[i].status === "Pending")
        ) {
          isReady = false;
        }
      }
      return isReady;
    },

    async validateData(type) {
      let isReady = true;
      let doc = this.currentDocument;

      if (type === "content") {
        let content =
          doc.content &&
          doc.content.revision &&
          doc.content.revision.length &&
          doc.content.revision[doc.content.revision.length - 1].text
            ? doc.content.revision[doc.content.revision.length - 1].text
            : null;

        if (
          !content ||
          !content.replace(/(<([^>]+)>)/gi, "").replace(/\s/g, "").length
        ) {
          isReady = false;
        }
      } else if (type === "photos") {
        if (!doc.items || !doc.items.length) {
          isReady = false;
        }
      }
      return isReady;
    },

    contentCanBeSubmitted() {
      // if (this.enableContentSave /* && !this.isWordsExceeded */) {
      //   this.setNewContent();
      // }
      let revCount = this.currentDocument.content.revision.length;
      return (
        this.currentDocument &&
        this.currentDocument.content &&
        this.currentDocument.content.revision &&
        this.currentDocument.content.revision.length &&
        this.currentDocument.content.revision[revCount - 1].text &&
        this.currentDocument.content.revision[revCount - 1].text
          .replace(/(<([^>]+)>)/gi, "")
          .replace(/\s/g, "").length &&
        this.currentDocument.content.revision[revCount - 1].owner === 'Parent' &&
        ['Approved', 'Review', 'AgencyReview'].indexOf(this.currentDocument.content.status) === -1
        && !this.isWordsExceeded
      );
    },
    photosCanBeSubmitted() {
      return (
        this.currentDocument &&
        this.currentDocument.items &&
        this.currentDocument.items.length && 
        this.currentDocument.items.filter(x => ['Approved', 'Review', 'AgencyReview'].indexOf(x.status) === -1).length
      );
    },
    coversCanBeSubmitted() {
      return (
        this.ProfileDocument &&
        this.ProfileDocument.special_pictures &&
        Object.keys(this.ProfileDocument.special_pictures).length &&
        this.ProfileDocument.special_pictures.front_cover &&
        this.ProfileDocument.special_pictures.front_cover.photo &&
        (!this.profileSettings.back_cover_required || (this.ProfileDocument.special_pictures.back_cover &&
        this.ProfileDocument.special_pictures.back_cover.photo)) &&
        (!this.profileSettings.center_spread_required || (this.ProfileDocument.special_pictures.center_spread &&
        this.ProfileDocument.special_pictures.center_spread.photo)) &&
        /* Any one not approved/waiting for review */
        (
          (this.ProfileDocument.special_pictures.front_cover && ['Approved', 'Review', 'AgencyReview'].indexOf(this.ProfileDocument.special_pictures.front_cover.status) === -1) ||
          (this.ProfileDocument.special_pictures.back_cover && ['Approved', 'Review', 'AgencyReview'].indexOf(this.ProfileDocument.special_pictures.back_cover.status) === -1) ||
          (this.ProfileDocument.special_pictures.center_spread && ['Approved', 'Review', 'AgencyReview'].indexOf(this.ProfileDocument.special_pictures.center_spread.status) === -1)
        )
      );
    },
    editContent() {
      if (
        this.currentDocument &&
        this.currentDocument.content &&
        this.currentDocument.content.revision &&
        this.currentDocument.content.revision.length
      ) {
        let revLength = this.currentDocument.content.revision.length;
        this.currentDocument.content.revision.push({
          text: this.currentDocument.content.revision[revLength - 1].text,
          owner: "Parent",
          date: (new Date()).toISOString()
        });
        this.currentDocument.content.status = 'Saved';
        this.currentDocument.content.status_date = (new Date()).toISOString();
      }
      /* Switch to the new tab */
      this.contentsModel = `tab-${this.currentDocument.content.revision.length}`;
    },
    editPhotoCaption (item, index) {
      if (this.ProfileDocument.submitted) {
        return;
      }
      this.currentEditPhotoIndex = index;
      this.currentEditPhoto = item.photo.id;
      this.isEdit = true;
      this.editPhotoItem = item.photo;
    },
    async savePhotoCaption () {
      if (this.currentEditPhotoIndex > -1) {
        let { error, data, status } = await update(
          'Photo',
          this.editPhotoItem,
          this.editPhotoItem.id
        );
        if (error) {
          console.log('error', error);
        } else {
          this.currentDocument.items[this.currentEditPhotoIndex].photo = data;
          this.ProfileDocument.chapters[this.currentDocumentIndex] = this.currentDocument;
          this.ProfileDocument = this.ProfileDocument;
          this.removePhotoCaptionEdit();
          let albumPhotoIndex = this.profileAlbum.photo.findIndex(x => x.photo && x.photo.id.toString() === data.id.toString());
          if (albumPhotoIndex > -1) {
            this.profileAlbum.photo[albumPhotoIndex].photo = data;
            this.profileAlbum = this.profileAlbum;
          }
          // swal.fire({
          //   type: 'success',
          //   title: 'Caption updated successfully',
          //   timer: 2500,
          //   onClose: () => {}
          // });
        }
      }
    },
    editChapterTitle () {
      if (this.ProfileDocument.submitted) {
        return;
      }
      // this.currentChapterEditIndex = index;
      // this.currentChapterEdit = item._id;
      this.chapterTitleTemp = this.currentDocument.name;
      this.isEditChapterTitle = true;
      // this.editChapterItem = item;
    },
    async saveChapterTitle () {
      if (this.currentDocument && this.currentDocumentIndex > -1) {
        if (this.chapterTitleTemp && this.chapterTitleTemp.trim() !== this.currentDocument.name) {
          this.currentDocument.name = this.chapterTitleTemp.trim();
          this.ProfileDocument.chapters[this.currentDocumentIndex] = this.currentDocument;
          let { error, data } = await this.updateProfileDocument('title');
          if (error) {
            console.log('error', error);
          }
        }
      }
      this.isEditChapterTitle = false;
      this.chapterTitleTemp = '';
    },
    updateContentStatus(status) {
      if (!status || !this.currentDocument) {
        return;
      }
      swal
        .fire({
          title: "Sure?",
          text: `Are you sure to change the content status into '${status}'?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, go ahead!"
        })
        .then(async result => {
          if (result.value) {
            let suggestionText = null;
            if (status === "Suggestion") {
              const { value: suggestion } = await swal.fire({
                title: "Please add your suggestion",
                input: "textarea",
                inputValue: "",
                inputPlaceholder: "Type your suggestion here...",
                showCancelButton: true,
                inputValidator: value => {
                  if (!value) {
                    return "You need to enter the suggestion";
                  }
                }
              });
              if (suggestion && suggestion.trim()) {
                suggestionText = suggestion;
              }
            }

            if (
              status !== "Suggestion" ||
              (suggestionText && suggestionText.trim())
            ) {
              /* change the status and update the document */
              this.currentDocument.content.status = status;
              this.currentDocument.content.status_date = new Date().toISOString();
              if (suggestionText) {
                this.currentDocument.content.description = suggestionText;
              }
              this.ProfileDocument.chapters[
                this.currentDocumentIndex
              ] = this.currentDocument;
              this.ProfileDocument = this.ProfileDocument;

              await this.updateProfileDocument(
                "contentStatus",
                status,
                suggestionText
              );

              /* Create the message */
              this.message.content = '<v-layout>';
              this.message.content += `<p>The content suggestion for the chapter "${this.currentDocument.name}" was approved by the parent.</p>`;
              this.message.content += `<p><span class="pf-bg-white pa-2 border-radius-10 elevation-1 pf-font-12 ${ this.statusTexts['Approved'].class }"><i aria-hidden="true" class="mr-1 v-icon material-icons theme--light ${ this.statusTexts['Approved'].class }" style="font-size: 16px;">${ this.statusTexts['Approved'].icon }</i>${ this.statusTexts['Approved'].text }</span></p>`;
              this.message.content += `</v-layout>`;
              await this.send(true);
            }
          }
        });
    },

    approveProfilePDF () {

      if (!this.profileSettings.agency_approval_required || !this.accountDetails.default_agency) {
        this.updatePDFStatus('Approved');
      } else {
        this.updatePDFStatus('AgencyReview');
      }

    },

    updatePDFStatus(status) {
      if (!status || !this.ProfileDocument || !this.ProfileDocument.pdf) {
        return;
      }
      let text = ['Approved', 'AgencyReview'].indexOf(status) > -1  ? 'approve' : 'add suggestions on';
      swal
        .fire({
          title: "Sure?",
          text: `Are you sure to ${text} the profile book?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, go ahead!"
        })
        .then(async result => {
          if (result.value) {
            window.getApp.$emit('BGProgress', false);
            let suggestionText = null;
            if (status === "Need Attention") {
              const { value: suggestion } = await swal.fire({
                title: "Please add your suggestion",
                input: "textarea",
                inputValue: "",
                inputPlaceholder: "Type your suggestion here...",
                showCancelButton: true,
                inputValidator: value => {
                  if (!value) {
                    return "You need to enter the suggestion";
                  }
                }
              });
              if (suggestion && suggestion.trim()) {
                suggestionText = suggestion;
              }
            }

            if (
              status !== "Need Attention" ||
              (suggestionText && suggestionText.trim())
            ) {
              /* change the status and update the document */
              if (!this.ProfileDocument.pdf.review_history) {
                this.ProfileDocument.pdf.review_history = [];
              }
              let newStatus = {
                status: status,
                status_date: new Date().toISOString(),
              };
              if (status === 'AgencyReview') {
                newStatus.agency = this.accountDetails.default_agency;
              }
              if (suggestionText) {
                newStatus.description = suggestionText;
              }
              this.ProfileDocument.pdf.review_history.push(newStatus);
              
              this.ProfileDocument.request_from = status === 'Approved' ? 'PDFApproved' : 'AgencyReview';
              this.ProfileDocument = this.ProfileDocument;

              await this.updateProfileDocument(
                "pdfStatus",
                status,
                suggestionText
              );

              /* Trigger the Flipbook generation process */
              if (status === 'Approved') {
                await this.createFlipbook();
              }
            }
            window.getApp.$emit('BGProgress', true);
          }
        });
    },

    async createFlipbook () {
      
      if (this.ProfileDocument && this.ProfileDocument.pdf && this.ProfileDocument.pdf.template) {
        let pdf = this.ProfileDocument.pdf.template;

        let { error, data, status } = await request('Flipbook', 'POST', { template: pdf.id, request_from: 'PDFApprove' });
        if (error) {
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Something went wrong, please try again.'
          };
        } else {
          // Create the timeline
          let timelineData = {
            title: 'Requested Flipbook',
            text: `You've requested to generate a flipbook - '${pdf.name}'`,
            account: this.Account.id
          };
  
          let { error, data, status } = await create('Timeline', timelineData);
          if (error) {
            console.log('error', error);
            this.snackbar = {
              show: true,
              color: 'orange',
              text: 'Failed to create the timeline'
            };
          } else {
            swal.fire(
              'Success!',
              'We initiated the profile flipbook processing, please check back your dashboard in a few minutes',
              'success'
            );
          }
        }
      }

    },

    // async saveDesignTemplate () {
    //   if (!this.ProfileDocument.design) {
    //     this.ProfileDocument.design = {};
    //   }
    //   // if (this.flipbookViewModal && this.currentTemplate) {
    //   //   this.design.template = this.currentTemplate.name;
    //   // }
    //   if (this.design.template && this.profileSettings.design_templates && this.profileSettings.design_templates.findIndex(x => x.name === this.design.template) > -1) {
    //     this.ProfileDocument.design.template = this.design.template;
    //   } else {
    //     this.ProfileDocument.design.template = '';
    //   }

    //   window.getApp.$emit('BGProgress', true);
    //   let { error, data } = await this.updateProfileDocument();
    //   window.getApp.$emit('BGProgress', false);
    //   if (!error) {
    //     this.isSaveTemplate = false;
    //     // this.closeFlipbookView();
    //     /* swal.fire({
    //       type: "success",
    //       title: "Success",
    //       text: `The design preferences were updated successfully`,
    //       timer: 2500
    //     }); */
    //   }
    // },
    /* async saveColorPreferences () {
      if (!this.ProfileDocument.design) {
        this.ProfileDocument.design = {};
      }
      if (this.design.colors && this.design.colors.length && this.design.colors.length > 2) {
        this.ProfileDocument.design.colors = this.design.colors;
      }
      let { error, data } = await this.updateProfileDocument();
      if (!error) {
        swal.fire({
          type: "success",
          title: "Success",
          text: `The color preferences were updated successfully`,
          timer: 2500
        });
        this.isSaveColors = false;
      }
    }, */
    /* async optCustomDesign () {
      if (!this.ProfileDocument.design) {
        this.ProfileDocument.design = {};
      }
      this.ProfileDocument.design.no_preference = this.design.no_preference;
      await this.updateProfileDocument();
    }, */
    
    viewAlbum (album, index) {
      this.currentAlbum = album;
      this.currentAlbumIndex = index;
    },
    backFromPhotos () {
      this.currentAlbum = null;
      this.currentAlbumIndex = -1;
    },
    showCommentsTips (type) {
      if (type === 'tips') {
        this.tipsTabs = 'tab-1';
        this.showComments = false;
        this.showTips = !this.showTips;
      } else {
        this.tipsTabs = 'tab-2';
        this.showTips = false;
        this.showComments = !this.showComments;
      }
      /* Trigger window resize to re-arrange the photos */
      window.dispatchEvent(new Event('resize'));
    },
    closeCommentsTips() {
      this.showComments = this.showTips = false;
      /* Trigger window resize to re-arrange the photos */
      window.dispatchEvent(new Event('resize'));
    },
    getFlipbookFirstPage (flipbook) {
      let firstPage = null;
      if (flipbook) {
        firstPage = flipbook.substring(flipbook.lastIndexOf('/'), -1) + '/files/picon/1.jpeg';
      }
      return firstPage;
    },
    // viewFlipbook (template, index) {
    //   this.currentTemplate = template;
    //   this.currentTemplateIndex = index;
    //   this.flipbookViewModal = true;
    // },
    // closeFlipbookView () {
    //   this.currentTemplate = null;
    //   this.currentTemplateIndex = -1;
    //   this.flipbookViewModal = false;
    // },
    async downloadItem (template) {
      if (template && template.file) {

        let pdfTemplateId = template.file.substring(template.file.lastIndexOf('/'), -1);
        pdfTemplateId = pdfTemplateId.substring(pdfTemplateId.lastIndexOf('/') + 1, pdfTemplateId.length);
        let pdfUrl = null;
        if (pdfTemplateId) {
          /* Get the pdf template */
          let { error, data: pdfTemplate } = await getOne('PdfTemplate', pdfTemplateId);
          if (error) {
            console.log(error);
          } else if (pdfTemplate && pdfTemplate.file && pdfTemplate.file.webPath) {
            try {
              pdfUrl = config.uploadPath + pdfTemplate.file.webPath;
              JSZipUtils.getBinaryContent(pdfUrl, function (err, data) {
                if (err) {
                  throw err; // or handle the error
                }
                saveAs(data, pdfTemplate.file.webPath.substr(pdfTemplate.file.webPath.lastIndexOf('/') + 1));
              });
            } catch (e) {
              this.snackbar = {
                show: true,
                color: 'red',
                text: 'Failed to load download the file'
              };
              if (pdfUrl) {
                window.open(pdfUrl);
              }
            }
          }
        }

      }
    },
    // shareFlipbookLink (template) {
      // this.isShareFlipbook = true;
      // this.sharedFlipbookLink = template.file;
    // },
    // async submitFlipbookLink () {
    //   if (this.$refs.flipbookLinkShareForm.validate()) {
    //     let payload = {
    //       account: this.Account.id,
    //       toEmail: this.flipbookShareData.email,
    //       message: this.flipbookShareData.message,
    //       flipbook: this.sharedFlipbookLink
    //     };

    //     let { error, data, status } = await request('Email/shareFlipbookLink', 'POST', payload);
    //     if (error) {
    //       console.log('error', error);
    //     } else {
    //       this.flipbookShareData = {
    //         email: '',
    //         message: ''
    //       };
    //       this.sharedFlipbookLink = '';
    //       this.isShareFlipbook = false;
    //       // swal.fire({
    //       //   type: 'success',
    //       //   title: 'Your message was sent successfully',
    //       //   timer: 2500,
    //       //   onClose: () => {
    //       //     /*  */
    //       //   }
    //       // });
    //     }
    //   }
    // },
    getCoverImage (photo, type = 'webview_url') {
      if (!photo || !type) {
        return;
      }
      if (photo[type]) {
        return `${photo[type].indexOf('http') === -1 ? config.s3BucketPath : '' }${photo[type]}`;
      }
      return false;
    },
    viewCoverPhoto(photo) {
      /* Return if no photo */
      if (!photo || !this.ProfileDocument.special_pictures || !this.ProfileDocument.special_pictures[photo.key]) {
        return;
      }
      this.currentCoverPhoto = this.ProfileDocument.special_pictures[photo.key];
      this.coverPhotoType = photo.key;
      this.isCoverPhotoView = true;

      /* Set the photo dimensions */
      this.setPhotoDimensions(photo);
    },
    closeViewCoverPhoto () {
      this.currentCoverPhoto = null;
      this.currentPhotoDim = null;
      this.coverPhotoType = null;
      this.isCoverPhotoView = false;
    },
    viewPhoto(photo, index) {
      /* Return if no photo */
      if (!photo || index === -1) {
        return;
      }
      this.currentPhoto = photo;
      this.currentPhotoIndex = index;
      this.isPhotoView = true;
      
      /* Set the photo dimensions */
      this.setPhotoDimensions(photo);
    },

    setPhotoDimensions (photo) {
      photo = photo.photo || null;
      let self = this;
      if (photo && photo.original_url) {
        let img = new Image();
        img.src = photo.original_url;
        img.onload = function () {
          self.currentPhotoDim = `${img.width}x${img.height}`;
        };
      }
    },

    closeViewPhoto () {
      this.currentPhoto = null;
      this.currentPhotoDim = null;
      this.currentPhotoIndex = -1;
      this.isPhotoView = false;
    },
    changeCurrentPhoto (type) {
      if (!type) {
        return;
      }
      /* Return if last photo and click next, and first photo and click back */
      if ((type === 'back' && this.currentPhotoIndex === 0) || (type === 'next' && this.currentPhotoIndex === this.currentDocument.items.length - 1)) {
        return;
      }
      switch (type) {
        case 'back':
          this.currentPhotoIndex -= 1;
          this.currentPhoto = this.currentDocument.items[this.currentPhotoIndex];
          break;
        case 'next':
          this.currentPhotoIndex += 1;
          this.currentPhoto = this.currentDocument.items[this.currentPhotoIndex];
          break;
        default:
          break;
      }
    },
    chapterSliderChanged (photoIndex, index) {
      if (photoIndex > -1 && index > -1) {
        this.chapterPhotoSlides[index] = photoIndex;
        this.chapterPhotoSlides = this.chapterPhotoSlides;
      }
    },
    currentChapterPhoto (index) {
      if (typeof this.chapterPhotoSlides[index] !== 'undefined') {
        return this.chapterPhotoSlides[index] + 1;
      }
      return 1;
    },
    changedTipsTab (tabId) {
      if (tabId === 'tab-1') {
        this.showTips = true;
        this.showComments = false;
      } else  {
        this.showComments = true;
        this.showTips = false;
      }
    },
    mainTabsChange (tabId) {
      if (tabId) {
        if (tabId === 'tab-3') {
          /* Set the currentTipsText */
          if (this.profileSettings.tips_text && this.profileSettings.tips_text.covers_spread) {
            this.currentTipsText = this.profileSettings.tips_text.covers_spread;
          }
          /* Load the cover conversation */
          this.loadConversation(true);

          /* Start the tour */
          this.showTours('PF.ProfileDoc.Covers.Expired', 'coversTour');
          
        } else if (tabId === 'tab-2') {
          /* Start the tour */
          this.showTours('PF.ProfileDoc.Chapters.Expired', 'chaptersTour');
        }
      }
    },
    chapterTabsChange (tabId) {
      this.showComments = this.showTips = false;
      if (tabId && tabId === 'tab-2') {
        /* Set to add photo if no items available */
        if (this.currentDocument && (!this.currentDocument.items || !this.currentDocument.items.length)) {
          this.selectPhotos();
        }
        /* Unset the isCaptionsMissing */
        this.isCaptionsMissing = false;
      }
    },
    removeSpecialPicture (photo) {

      swal.fire({
        title: 'Are you sure?',
        text: `Do you want to remove the ${photo.name} ?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, remove it!'
      }).then(async (result) => {
        if (result.value) {
          (async () => {
            if (this.ProfileDocument.special_pictures[photo.key] && this.ProfileDocument.special_pictures[photo.key].status !== 'Approved') {
              this.ProfileDocument.special_pictures[photo.key] = {
                status: 'Pending',
                status_date: (new Date()).toISOString()
              };
              this[photo.key] = null;
              await this.updateProfileDocument();
            }
          })();
        }
      });

    }
  }
};
</script>

<style scoped>
.playbackButton {
  top: calc(50% - 19px);
  left: calc(50% - 19px);
}
.v-menu__content {
  margin-top: 28px;
}
.image_class {
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 120px;
  width: 100%;
}
.special_image {
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  /* height: 209px; */
  width: 100%;
}
.thumb_image {
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 35px;
  width: 100%;
}
.text-truncate {
  line-height: inherit !important;
}
.image-view {
  width: 100%;
}
.vc-chrome, .vc-photoshop {
  position: absolute;
  top: 0;
  z-index: 1;
}
.section-tab-counter {
  padding: 2px 7px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/ProfileDocuments/parent.vue